// access localized strings by using the following lines of code
// import {useStore} from "react-redux";
// const i18n = useStore().getState().i18n;
// e.g. i18n.forgot_password => "Passwort vergessen?" (de)

function i18n(language) {

  const localizedStrings = {
    // English language
    en: {
      change_password: "Change Password",

      update_user: "Update new User",
      year: "Year",
      admin_scope_header: "Dashboard",
      admin_scope_header_desc:
        "Here you can create new users for MesuLink within your organization.",
      scopeHeader: {
        dashboardTitle: "Dashboard",
        dashboardDescription:
          "The dashboard shows which of your equipment have abnormalities so you can respond immediately.",
        sparePartsTitle: "Spare Parts",
        sparePartsDescription: "Manage and overview spare parts.",
        trainingTitle: "Training",
        trainingDescription: "Manage and overview training content.",
        customerTrainingsTitle: "Customer Trainings",
        customerTrainingsDescription:
          "Here you can find the contents of the global training program. You can only open the modules that you have booked.",
        customersTitle: "Customers",
        customersDescription:
          "Manage customer records, including sites and machines used at the customer.",
        customerPortalsTitle: "Customer Portals",
        customerPortalsDescription:
          "Configure your customers' online portals and adjust their presentation settings.",
        productTypesTitle: "Product Types",
        productTypesDescription:
          "Manage machine-builder product types and assign product-specific content such as documents and FAQs.",
        equipmentTitle: "Equipment",
        equipmentDescription:
          "Manage equipment pools and their assigned equipment.",
        exportTitle: "Export",
        exportDescription:
          "Export stored 247UpTime data such as messages and counter values.",
        openNotificationsTitle: "Open Notifications",
        openNotificationsDescription:
          "Get an overview of current issues or create new notifications for your colleagues.",
        sitesTitle: "Sites",
        sitesDescription: "Manage your sites and their related areas.",
        maintenanceTitle: "Planned Maintenance",
        maintenanceDescription:
          "Track and plan recurring maintenance and inspections.",
        taskPlanningTitle: "Task Planning",
        taskPlanningDescription:
          "Assign open notifications to team members and keep track of them.",
        helpFeedbackTitle: "Help & Feedback",
        helpFeedbackDescription:
          "Read about 247UpTime features or leave feedback about the software.",
        sparePartsPlaceholder: "Spare parts area is prepared.",
        trainingPlaceholder: "Training area is prepared.",
        customerTrainingsPlaceholder: "Customer training area is prepared.",
      },

      customerPortal_tabCustomerPortals: "Customer Portals",
      customerPortal_tabSettings: "Settings",
      customerPortal_tableTitle: "Customer portals",
      customerPortal_searchPlaceholder: "Search customers",
      customerPortal_statusLabel: "Status",
      customerPortal_statusAll: "all",
      customerPortal_statusPublished: "published",
      customerPortal_statusPlanned: "planned",
      customerPortal_statusOffline: "offline",
      customerPortal_statusNotConfigured: "not configured",
      customerPortal_emptyTitle: "You have not created any customers yet",
      customerPortal_emptyHint:
        "To manage a customer portal, you must first create a customer.",
      customerPortal_emptyAction: "Create new customer",
      customerPortal_entriesPerPage: "%s entries per page",
      customerPortal_settingsTitle: "Settings",
      customerPortal_settingsDescription:
        "These settings apply to all customer portals unless a portal has its own settings.",
      customerPortal_displayTitle: "Customer portal appearance",
      customerPortal_logoUploadLabel: "Upload logo",
      customerPortal_logoLabel: "Logo",
      customerPortal_primaryColorLabel: "Primary color",
      customerPortal_hexLabel: "HEX code",
      customerPortal_previewTitle: "Preview of your customer portal style",
      customerPortal_bannerTitle: "Header areas",
      customerPortal_bannerDescription: "This is how header areas look inside the application.",
      customerPortal_previewHeadline: "Headlines",
      customerPortal_previewLinks: "Links",
      customerPortal_previewDefaultText: "Default text",
      customerPortal_previewPrimaryButton: "+ Button",
      customerPortal_previewSecondaryButton: "+ Button",
      customerPortal_saveChanges: "Save changes",
      customerPortal_portalUrlTitle: "URL for customer portals",
      customerPortal_portalUrlDescription:
        "You can store a company-specific address for your customer portals.",
      customerPortal_portalUrlDescriptionSuffix: "Please use",
      customerPortal_standardAddressNote:
        "Your customer portal is also always reachable under the standard address.",
      customerPortal_standardAddressLabel: "Standard address",
      customerPortal_openGuideLink: "our guide",
      customerPortal_customAddressLabel: "Custom address",
      customerPortal_customAddressPlaceholder: "e.g. customername.com/customerportal",
      customerPortal_customAddressExample: "e.g. customername.com/customerportal",
      customerPortal_helpStatusLabel: "Status",
      customerPortal_siteTableTitle: "Sites",
      customerPortal_siteSearchPlaceholder: "Search sites",
      customerPortal_siteHeaderName: "Site name",
      customerPortal_siteHeaderCompany: "Company",
      customerPortal_siteHeaderCity: "City",
      customerPortal_siteHeaderCountry: "Country",
      customerPortal_siteHeaderMachines: "Machines",
      customerPortal_helpTitle: "Set up a custom address",
      customerPortal_helpIntro:
        "To make your customer portals available under your own domain, a few steps are required. Please share these instructions with your web administrator.",
      customerPortal_helpStep1Title: "1. 247Access: enter the URL in settings",
      customerPortal_helpStep1Body:
        "Enter your custom web address (e.g. https://customername.com/customerportal/) in 247Access and save the changes.",
      customerPortal_helpStep1StatusPrefix:
        "After entering a valid URL you will see the status",
      customerPortal_helpStep1StatusValue: "Availability pending",
      customerPortal_helpStep2Title: "2. Your server: make the changes",
      customerPortal_helpStep2Body:
        "You can choose one of the following configuration options. Use the URLs from the previous page.",
      customerPortal_helpDnsTitle: "DNS entry:",
      customerPortal_helpDnsBody:
        "Create a CNAME record that points from your custom web address to your standard address.",
      customerPortal_helpProxyTitle: "Reverse proxy:",
      customerPortal_helpProxyBody:
        "Forward requests from your standard address to your custom address.",
      customerPortal_helpStep2Footer:
        "Please note that the changes may take up to 48 hours. Once your customer portals are reachable under your custom address, you will see the status",
      customerPortal_helpStep2StatusValue: "Customer portal reachable",
      customerPortal_closeWindow: "Close window",
      reset_password_title: "Reset password",
      reset_password_description: "You will receive an email to reset your password.",
      reset_password_request_button: "REQUEST EMAIL",
      reset_password_back_to_login: "Back to login",
      reset_password_success:
        "We have sent an email to your account, please check your email. Thanks.",
      reset_password_login_link: "==>Login Page",
      email_address: "E-mail address",

      customerTrainings_pageTitle: "Customer Trainings",
      customerTrainings_filterBooked: "Only booked",
      customerTrainings_introTitle: "Individual trainings",
      customerTrainings_introDescription:
        "If you have questions about the contents or would like customized training, please contact us.",
      customerTrainings_contactName: "Luisa Herrgardt",
      customerTrainings_contactEmail: "trainings@fette-compacting.com",
      customerTrainings_contactHours: "Mon.-Fri. 09–18 h",
      customerTrainings_durationLabel: "Duration",
      customerTrainings_duration1Day: "Duration: 1 day",
      customerTrainings_duration2Days: "Duration: 2 days",
      customerTrainings_cardActionStart: "Start Training",
      customerTrainings_cardActionBook: "Book Training",
      customerTrainings_bookingSuccess: "Training booked successfully.",
      customerTrainings_bookingError: "Training booking could not be completed.",
      customerTrainings_apiError:
        "Customer trainings could not be loaded from the API.",
      customerTrainings_emptyState: "No customer trainings available.",
      customerTrainings_module1_title: "Introduction",
      customerTrainings_module1_target:
        "Target group: machine operators, maintenance staff, machine setters, project developers, quality managers, technologists, project managers, IT administrators, production managers",
      customerTrainings_module1_description:
        "After this training, you will understand the operating principle of a tablet press and be familiar with the technical terms. You will know all machine safety functions and have produced your first tablet.",
      customerTrainings_module2_title: "Operation",
      customerTrainings_module2_target:
        "Target group: machine operators, machine setters, quality managers, technologists",
      customerTrainings_module2_description:
        "In this training you will learn how to set up and operate the tablet press safely and efficiently. You will practice the most important operating steps and learn how to respond correctly to common production scenarios.",
      customerTrainings_module3_title: "Mechanical Maintenance",
      customerTrainings_module3_target:
        "Target group: maintenance staff",
      customerTrainings_module3_description:
        "This training covers mechanical maintenance tasks, inspection routines and safe handling of the machine components.",
      customerTrainings_module4_title: "Electronic Maintenance",
      customerTrainings_module4_target:
        "Target group: maintenance staff",
      customerTrainings_module4_description:
        "This training covers electronic components, diagnostics and safe troubleshooting for the tablet press.",
      customerTrainings_module5_title: "Dismantling Arm",
      customerTrainings_module5_target:
        "Target group: maintenance staff",
      customerTrainings_module5_description:
        "Learn how to safely use the dismantling arm and perform efficient service work on the machine.",
      customerTrainings_module6_title: "Cleaning and Setup",
      customerTrainings_module6_target:
        "Target group: maintenance staff, machine operators",
      customerTrainings_module6_description:
        "This training covers cleaning, setup and safe preparation of the tablet press for the next production run.",
      customerTrainings_detailBack: "Customer Trainings",
      customerTrainings_detailInfoCustomer: "Customer: Pfizer Deutschland",
      customerTrainings_detailInfoUserId: "User ID",
      customerTrainings_detailTabOverview: "Overview",
      customerTrainings_detailTabDigitalLearning: "Digital Learning Room",
      customerTrainings_detailAboutTitle: "About this training",
      customerTrainings_detailTargetGroupTitle: "Target group",
      customerTrainings_detailDownloadsTitle: "Downloads for modules",
      customerTrainings_detailLanguageLabel: "Language",
      customerTrainings_detailLanguageGerman: "German",
      customerTrainings_detailLanguageFrench: "French",
      customerTrainings_detailLanguageEnglish: "English",
      customerTrainings_detailDownloadsEmpty:
        "No attachments are available for the selected language.",
      customerTrainings_detailSectionGeneral: "General content (4)",
      customerTrainings_detailSectionAdvanced: "Advanced content (12)",
      customerTrainings_detailSectionKnowledgeCheck: "Learning objective check (4)",
      customerTrainings_detailSectionCertificates: "Certificates (3)",
      customerTrainings_detailDocItem1Title: "P3000 Operating manual 2023-01",
      customerTrainings_detailDocItem1Description:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit.",
      customerTrainings_detailDocItem2Title: "Operating manual setup ZQP2",
      customerTrainings_detailDocItem2Description:
        "Lorem ipsum dolor sit aiscing elit. Aenean commodo ligula eget dolor.",
      customerTrainings_detailDocItem3Title: "Additional information P3000",
      customerTrainings_detailDocItem4Title: "Safety instruction P3000",
      customerTrainings_detailSectionComingSoon:
        "Content for this module section will be available soon.",
      customerTrainings_detailDigitalLearning: "Digital Learning Room",
      customerTrainings_detailDigitalLearningHint:
        "Digital training material for this module is prepared and will be available soon.",

      user_table_status: "status",
      user_table_Vorname: "First name",
      user_table_Nachname: "Last name",
      user_table_Benutzertyp: "User type",
      user_table_email: "E-mail address",

      land_germany_name: "Germany",
      land_germany_value: "en",

      land_austria_name: "Austria",
      land_austria_value: "en",

      land_swiss_name: "Swiss",
      land_swiss_value: "en",

      land_checkrepulic_name: "czeckreuplic",
      land_checkrepublic_value: "en",

      land_poland_name: "Poland",
      land_poland_value: "en",

      create_equipment_title: "Create new equipment",

      create_site_title: "Create new Site",
      create_area_title: "Create New Area",

      update_site_title: "Update Site",
      update_area_title: "Update Area",

      dashboard_initial_factory_title: "Create works",
      dashboard_initial_equipment_title: "Create and assign equipment",
      dashboard_initial_users_title: "Create additional 247UpTime users",
      dashboard_initial_final_title: "Create and assign equipment",
      no_time_range_selected: "No time range selected",
      dashboard_initial_factory_tooltip: "Define your local structure from sites and areas",
      dashboard_initial_equipment_tooltip: "Define your logical structure from pools",
      dashboard_initial_users_tooltip: "Add additional users",
      dashboard_initial_final_tooltip:
        "You can only add equipment after creating a site/area or a pool.",
      dashboard_empty_open_notifications: "No open notifications in the selected time range.",
      dashboard_empty_welcome:
        "Welcome to %s! No equipment has been added yet. Please open your user profile.",
      
      dashboard_kpi_mtbf: "MTBF",
      dashboard_kpi_mtbf_tooltip: "MTBF = operating hours / number of unplanned downtimes",
      dashboard_kpi_maintenance_done: "Maintenance completed",
      dashboard_kpi_maintenance_done_tooltip:
        "Planned maintenance (completed) / planned maintenance (total)",
      dashboard_kpi_unplanned_downtimes: "Unplanned downtimes",
      dashboard_kpi_unplanned_downtimes_tooltip:
        "All unplanned downtimes from the last 12 months",
      dashboard_kpi_total_range: "full period",
      dashboard_kpi_last_12_months: "last 12 months",

      dashboard_initial_state_title:
        "Hello, %s!<br> Continue setting up 247UpTime.",
      dashboard_initial_state_description:
        "After the initial setup, you can create additional works, equipment and users at any time.",

      construction_year: "Construction year",
      carry_now: "carry out now",
      footer_contact: "Contact",
      empty_dashboard_button: "Open profile & settings",
      empty_dashboard_title: "You have not subscribed to any machines yet",
      empty_dashboard_desc:
        "To subscribe to machines, go to your user profile and select the relevant sites or machine pools under Your machines.",
      export_machine_details: "Export Machines Data",
      footer_data_protection: "data protection",
      footer_impressum: "imprint",
      equipment_serial_number: "Serial Number",
      save: "Save",
      next_appointment: "Next Appointment",
      due_on: "Due on",
      rotation: "Rotation",
      reported: "Reported",
      no_notifications:
        "No new notifications. We’ll notifiy you as soon as there are new incidents.",
      sites: "Sites",
      counter_Type: "Counter Type",
      add_new_counter: "NEW",
      new_badge: "NEW",
      tab_counters: "Counters",
      streetnumber: "Street",
      postalCode: "Postal Code",
      city: "City",
      firmName: "Company name",
      homePage: "Homepage",
      land: "Country",
      firm_details: "DETAILS ABOUT YOUR COMPANY",
      email: "Email address",
      password: "Password",
      forgot_password: "Forgot password?",
      loginHeading: "Log in",
      loginButton: "Log in",
      registration: "Registration",
      no_account: "You dont have any account?",
      register_for_free: "Register for free",
      searchplaceholder_tablet: "Search for machines, …",
      searchplaceholder_phone: "Search for machines, etc.",
      createnewissue: "Create new issue",
      update_notification: "Edit Notification",
      opennotifications: "Open Notifications",
      machineparks: "Machine parks",
      machinepark: "Machine park",
      all_machineparks: "All Machine parks",
      factorysections: "Factory sections",
      machinecategory: "Machine category",
      machinestatus: "Machine status",
      groupby: "Group by",
      timerange: "Time range",
      show_n_more: "Show %s more",
      show_less: "Show less",
      // empty_notifications: 'There are currently no unresolved issues. Keep it up!',
      empty_notifications: "derzeit keine",
      notification_singular: "Notification",
      notification_plural: "Notifications",
      // avg_solutiontime: 'Ø Solution Time',
      avg_solutiontime: "MTTR",
      incidents: "Incidents",
      statistics: "Statistics",
      new_issue: "New Issue",
      create_new_notification: "Create New Notification",
      save_notification: "Save",
      filter_sorting: "Filter & Sorting",
      filter: "Filter",
      sorting: "Sorting",
      unresolved: "unresolved",
      day: "day",
      days: "days",
      empty_machineparks:
        "No machine parks have been set up yet. Please contact the administrator.",
      undisturbed: "undisturbed",
      disturbed: "Malfunction",
      tab_dashboard: "Dashboard",
      tab_machineparks: "Machine Parks",
      tab_messages: "Messages",
      super_tab_clients: "Clients",
      super_tab_users: "Users",
      super_tab_brands: "Brands",
      super_tab_equipment_types: "Equipment Types",
      tab_notifications: "Notifications",
      manufacturer_serial_number: "Manufacturer Serial Number",
      heading_latest_notifications:
        "Latest Notifications & Scheduled Maintenance",
      go_to_machine_history: "Go to Machine History",
      heading_responsible: "Responsible",
      heading_manufacturer_service: "Manufacturer Service",
      heading_life_cycle: "Life Cycle",
      notificationtype: "Notification type",
      built_year: "Built year",
      empty_history: "The machine history does not show any notifications yet.",
      today: "Today",
      heading_documentation: "Documentation",
      file_powerpoint: "PowerPoint",
      file_excel: "Excel",
      file_word: "Word",
      file_email: "Email",
      file_word_macro: "Word (Macro)",
      file_odt: "ODT Document",
      file_ods: "ODS Spreadsheet",
      file_image: "Image",
      file_audio: "Audio",
      file_video: "Video",
      file_url: "Link",
      hasinternalattachment: "Interal Resources",
      hasmanufacturerattchment: "Manufacturer Resources",
      add_new_resource: "add new resource",
      add_ressource: "Add resource",
      upload_file: "Upload file",
      resource_vendor: "Classification",
      resource_type: "Type",
      resource_type_file: "File",
      resource_type_link: "Link",
      resource_type_photo: "Photo",
      resource_type_video: "Video",
      resource_url: "Link (URL)",
      change_file: "Change file",
      resource_name: "Resource title",
      resource_description: "Description (optional)",
      resource_language: "Language",
      resource_scope: "Scope",
      button_cancel: "cancel",
      button_yes: "Yes",
      button_no: "No",
      upload_attachment_title_upload: "Upload file",
      upload_attachment_title_edit: "Edit file",
      upload_attachment_choose_file: "Choose file...",
      upload_attachment_allowed_types:
        "Only text, PDF, Word and Excel files are allowed!",
      upload_attachment_display_name: "Display name",
      upload_attachment_short_description: "Short description (optional)",
      upload_attachment_category: "Category",
      upload_attachment_invalid_extension: "Invalid file extension!",
      empty_resources: "No resources have been added to this machine yet.",
      button_done: "Done",
      select_multiple_n: "multiple (%s)",
      header_data: "Header Data",
      referred_to_machine: "Concerned Machine",
      notification_title: "Notification Title",
      helpertext_notification_title: 'e.g. "Main spindle faulty"',
      referred_to_assembly: "Concerned Assembly",
      date: "Date",
      time: "Time",
      notification_share_title: "Share notification",
      notification_share_email_prompt: "Please enter the recipient's email address",
      notification_share_email_label: "Email",
      notification_share_send: "Send",
      notification_share_inline: "Share by e-mail",
      notification_delete: "Delete notification",
      notification_safety_notes: "Safety notes",
      notification_error_code: "Error code",
      problem_solution_status: "Status",
      notification_description: "Notification description",
      error_code: "Error code (optional)",
      describe_notification: "Describe the notification…",
      docs_empty_title: "You have not uploaded any files in this category yet",
      docs_empty_hint:
        "Upload a file. Tip: you can upload multiple files at the same time.",
      add_photos_videos: "Add photos/videos",
      capture_photo: "Capture new photo",
      capture_video: "Capture new video",
      add_from_gallery: "Add from gallery",
      add_attachments: "Add attachments",
      enter_description: "Enter description…",
      change_attachments: "Change attachments",
      notification_sucessfully_created:
        "The notification was successfully created",
      discuss_notification: "Discuss notification",
      go_to_machine: "go to machine",
      notificationtype_from: "%notificationtype from %datetime",
      reported_by: "reported by",
      machine: "Machine",
      images: "Images",
      no_images_yet: "No images have been added to this notification yet.",
      attachments: "Attachments",
      edit_notification: "Edit notification",
      notification_solved: "The notification has been successfully resolved.",
      close_notification_heading: "Close notification",
      close_notification_text:
        "Do you want to mark the notification as resolved and inform all participating instances about it?",
      settings: "Settings",
      chat_notifications: "Chat notifications",
      automatic_translation: "Automatic translation",
      activate: "activate",
      target_language: "Target language",
      involved_contacts_heading: "Involved Contacts",
      search_contacts: "Search contacts…",
      empty_discussion_contacts:
        "No contacts have been added to this discussion yet.",
      discussion_heading: "Discussion",
      error_chatroom_loading: "Failed to load chat room.",
      error_email_required: "Please enter your email address",
      error_email_format: "This is no valid email address",
      error_password_required: "Please enter your password",
      error_password_wrong: "Email and password do not match",
      enter_message: "Enter message…",
      add_new_kunden: "Create New Customer",
      time_h: "h",
      alert_trash_changes_body: "Do you want to discard the changes you made?",
      button_save_changes: "Save changes",
      logout: "Logout",
      product_types_back: "Product Types",
      product_types_title: "Create Product Type",
      product_types_description:
        "Your product types are the basis for the machines used by your customers. Product types let you manage product-specific content such as documents and FAQs centrally in one place and make it available to your customers.",
      product_types_footer_button: "Create Product Type",
      product_types_tab_overview: "Overview",
      product_types_tab_documents: "Documents",
      product_types_tab_faq: "FAQ",
      product_types_tab_maintenance_plan: "Maintenance Plan",
      product_types_tab_updates: "Updates",
      product_types_master_data: "Master Data",
      product_types_brand: "Brand name",
      product_types_product_class: "Product Class",
      product_types_type_name: "Type Name",
      product_types_faq_title: "Frequently Asked Questions and Answers",
      product_types_faq_empty_title: "You have not created any FAQs yet",
      product_types_faq_empty_description:
        "Store frequently asked questions and answers here to reduce support requests and document existing knowledge.",
      product_types_faq_empty_action: "New FAQ",
      product_types_faq_add_action: "Add FAQ",
      product_types_faq_edit_action: "Edit",
      product_types_faq_delete_action: "Delete",
      product_types_faq_save_action: "Save",
      product_types_faq_question_label: "Question",
      product_types_faq_answer_label: "Answer",
      product_types_version: "Version",
      product_types_date_range: "Date range",
      product_types_date_range_from: "From",
      product_types_date_range_to: "To",
      product_types_date_range_apply: "Apply",
      product_types_helper_type: "e.g. P3000",
      product_types_helper_product_class: "e.g. machine, tool, etc.",
      product_types_internal_notes: "Internal Notes",
      product_types_internal_notes_helper: "Not visible to your customers",
      product_types_title_list: "Product Types",
      product_types_new_button: "New",
      product_types_search_placeholder: "Search product types",
      product_types_filter_button: "Filter",
      product_types_filter_brand: "Brand",
      product_types_filter_product_class: "Product class",
      product_types_filter_equipment_class: "Produktklasse",
      product_types_filter_machine_class: "Machine class",
      product_types_header_type: "Type Name",
      product_types_header_brand: "Brand",
      product_types_header_product_class: "Product class",
      product_types_header_equipment_class: "Produktklasse",
      product_types_entries_per_page: "%s entries per page",
      product_types_all: "all",
      product_types_empty_title: "You have not created any product types yet",
      product_types_empty_description: "Create your first product type now.",
      product_types_empty_action: "Create new product type",
      product_types_placeholder_body:
        "This view will follow next. We are using the same typography and page structure as the rest of the product type area.",
      product_types_docs_title: "Product-specific Documents",
      product_types_docs_upload: "UPLOAD FILE",
      product_types_docs_empty_title:
        "You have not uploaded any files in this category yet",
      product_types_docs_empty_hint:
        "Upload a file now. Tip: You can upload several files at the same time.",
      product_types_docs_empty_action: "UPLOAD FILE",
      product_types_docs_file: "File",
      product_types_docs_uploading: "Uploading files",
      product_types_docs_dropzone_title: "Drop files here",
      product_types_docs_drop_hint:
        "Release the file to assign it to this product type category.",
      product_types_docs_category_operation: "Operation and setup",
      product_types_docs_category_setup: "Setup",
      product_types_docs_category_maintenance: "Maintenance and service",
      product_types_docs_category_safety: "Safety",
      product_types_docs_category_internal: "Internal instructions",
      nav: {
        customerPortal: "Customer Portal",
        customerTrainings: "Customer Trainings",
        dashboard: "Dashboard",
        adminArea: "Admin Area",
        customerManagement: "Customer Management",
        contentManagement: "Content Management",
        customers: "Customers",
        productTypes: "Product Types",
        spareParts: "Spare Parts",
        trainings: "Trainings",
        equipment: "Equipment",
        machineParks: "Machine Parks",
        sites: "Sites",
        createNewSite: "Create new site",
        machines: "Machines",
        plannedMaintenance: "Planned Maintenance",
        taskPlanning: "Task Planning",
        notifications: "Notifications",
        users: "Users",
        brands: "Brands",
        equipmentClasses: "Equipment Classes",
      },
      auth: {
        loginHeading: "Log in",
        loginButton: "Log in",
        passwordLabel: "Password",
        forgotPassword: "Forgot password?",
        registration: "Registration",
        noAccount: "You dont have any account?",
        registerForFree: "Register for free",
        changeEmailAddress: "Change email address",
        signupHeadline: "247UpTime free trial for 30 days",
        signupFeature1: "Test all functions and areas",
        signupFeature2: "Immediate availability",
        signupFeature3: "No credit card required",
        signupMailNotice:
          "Please check your inbox: An email with your activation link was sent to %s.",
        signupMailHint: "Click the link to complete your registration.",
        createAccount: "Create Account",
        toLogin: "Back to login",
        or: "or",
        signupContinue: "Continue",
      },
      help: {
        documentation: "Documentation",
        feedback: "Feedback",
        faq: "Frequently Asked Questions",
        sendFeedback: "Send feedback",
        feedbackSentTitle: "Message sent",
        feedbackSentText: "Thank you. We will get back to you as soon as possible.",
        feedbackTitle: "Leave feedback",
        feedbackTypeLabel: "Issue type",
        feedbackMessagePlaceholder: "Your message to us...",
        chooseFile: "Choose file...",
        supportPerson: "Konstantin",
        supportHours: "Mon.-Fri. 08-16 h",
        feedbackTypeGeneral: "General feedback",
        feedbackTypeSetup: "Issues setting up",
        feedbackTypeOperation: "Issues during operation",
        feedbackTypeFeatures: "Functionality and features",
        feedbackTypeOther: "Other",
      },
      site: {
        back: "Sites",
        createTitle: "Create Site",
        updateTitle: "Update Site",
        delete: "Delete site",
        nameLabel: "Site name",
        nameExample: "e.g. Site Oberpfaffenhofen",
        streetLabel: "Street and house number",
        addonLabel: "Address supplement (optional)",
        zipLabel: "ZIP code",
        cityLabel: "City",
        countryLabel: "Country",
        description:
          "Here you can manage the master data of a site. After the site is created, you can create areas and assign equipment.",
      },
      area: {
        createTitle: "Create Area",
        updateTitle: "Update Area",
        delete: "Delete area",
        scopeTitle: "Areas",
        description:
          "Your site can be divided into any number of areas, to which your equipment is assigned.",
        nameLabel: "Area name",
        nameExample: "e.g. Machining",
        idLabel: "Area ID",
        equipment: "Assigned equipment",
        selectEquipment: "Select equipment",
        operatingParameters: "Operating parameters",
        operatingHours: "Operating hours",
        copySettingsFromArea: "Use settings from area",
        chooseArea: "Please choose an area",
        configure: "Configure",
        operatingParametersEmpty:
          "No operating parameters have been created for %s yet.",
        operatingHoursEmpty: "No operating hours have been created for %s yet.",
      },
      profile: {
        pageTitle: "Your Profile",
        additionalDetails: "Additional Details",
        headingSafety: "Safety",
        passwordSection: "Your password",
        passwordDescription:
          "To change your password, enter your current password and your new password. Your password must be at least 8 characters long and contain an uppercase and a lowercase letter.",
        closeWindow: "Close window",
        uploadNewImage: "Upload new image",
        deletePhoto: "Delete photo",
        currentPassword: "Your current password",
        newPassword: "Enter new password",
        emailLabel: "Email",
        enterValidEmail: "Enter your valid email",
        reset: "Reset",
        yourPassword: "Your password",
        twoFactorTitle: "Set up two-factor authentication",
        twoFa_desc: "Please enter your six-digit authentication code here.",
        twoFactorDescription:
          "Two-factor authentication makes access to your user account even more secure. To use it, you need access to a mobile device with the Google Authenticator app.",
        twoFactorImportant:
          "Important: Please contact support if you want to change your two-factor authentication or if you have lost your device.",
        twoFactorSupportPrefix: "Important: Please contact the",
        twoFactorSupportSuffix:
          "if you want to change your two-factor authentication or if you have lost your device.",
        setupNow: "SET UP NOW",
        twoFactorActive: "Two-factor authentication activated",
        assignedEquipment: "Assigned equipment",
        assignedEquipmentHint:
          "Important: Only equipment selected here will appear in your dashboard. You will only receive notifications about selected items and upcoming maintenance.",
        sitesAndAreas: "Sites and areas",
        equipmentPools: "Equipment pools",
        profileEquipmentHint:
          "Here you can add equipment, such as machines, to your profile so they appear in the dashboard and push notifications are enabled.",
        languageLabel: "Language",
        languageGerman: "Deutsch",
        languageEnglish: "English",
      },
      users: {
        tabSubscription: "Your subscription",
        tabUsers: "Users",
        subscriptionSummaryTitle: "Subscription summary",
        currentPlan: "Current subscription",
        term: "Term",
        subscribedOn: "Subscribed on",
        autoRenewal: "Automatic renewal",
        noticePeriod: "Cancellation period",
        organizationName: "Organization name",
        userLimit: "User limit",
        subscription: "Subscription",
        billingTitle: "Billing",
        billingShipping: "Billing shipping",
        shipTo: "Ship to",
        contactSupport:
          "For changes to your subscription or billing, please contact support.",
        faqTitle: "Frequently Asked Questions",
        machine_faq_description:
          "Here you will find frequently asked questions and answers about this machine and can document your own questions and answers.",
        customerServiceTitle: "Customer service",
        searchPlaceholder: "Search users",
        filterButton: "Filter",
        filterAccountStatus: "User account status",
        filterUserType: "User type",
        statusAll: "all",
        statusActive: "Active",
        statusInactive: "Inactive",
        addNew: "+ NEW",
        tableStatus: "Status",
        tableFirstName: "First name",
        tableLastName: "Last name",
        tableUserType: "User type",
        tableEmail: "E-mail address",
        rowsPerPage: "Entries per page",
        newMessage: "New message",
        actions: "Actions",
        faqQ1:
          "I need more users than my limit allows. How can I add more?",
        faqA1:
          'Please send an email to <a href="mailto:247uptime@247factorynet.com">247uptime@247factorynet.com</a> with your Subscription ID and the desired number of users.',
        faqQ2: "How can I create more administrators?",
        faqA2: "Create a new user and assign the Admin role.",
        faqQ3: "Who can I contact for technical questions?",
        faqA3: "Please contact support@247factorynet.com for all requests.",
        faqQ4: "How do I manage my own user account?",
        faqA4:
          "Please choose Profile & Settings next to your name in the top-right corner.",
        faqQ5: "How can I cancel my 247uptime subscription?",
        faqA5:
          'If you want to cancel your subscription, please send us an email to <a href="mailto:247uptime@247factorynet.com">247uptime@247factorynet.com</a> and include your Subscription ID.',
        billingElectronic: "Electronic (by email)",
      },
      all_notificationtypes: "all notification types",
      notificationtype_malfunction: "Malfunction",
      notificationtype_abnormality: "Abnormality",
      notificationtype_memo: "Memo",
      notificationtype_task: "Task",
      notificationtype_internal_message: "Internal Message",
      notificationtype_manufacturer_message: "Manufacturer Message",
      notificationtype_planned_maintenance: "Planned Maintenance",
      notificationtype_maintenance: "Maintenance",
      avg_uptime: "Uptime",
      search_result: { sng: "Search Result", plr: "Search Results" },
      documents: "Documents",
      machines: "Machines",
      customer_details_csv_selected: "CSV file selected.",
      customer_details_csv_invalid: "Please choose a CSV file.",
      customer_details_csv_import_title: "CSV Import",
      customer_details_csv_import_drop_title: "Import CSV file",
      customer_details_csv_import_drop_description:
        "Drop your CSV file here or click to choose it. We validate the fixed header, preview the rows, and then create the machines in this equipment pool.",
      customer_details_csv_import_create: "Create equipments",
      customer_details_csv_import_cancel: "Cancel",
      customer_details_csv_import_success: "All CSV rows were created successfully.",
      customer_details_csv_import_progress: "Creating equipments...",
      customer_details_csv_import_rows: "rows",
      customer_details_csv_import_created: "created",
      customer_details_csv_import_failed: "failed",
      customer_details_csv_import_status_ready: "Ready",
      customer_details_csv_import_status_success: "Success",
      customer_details_csv_import_status_error: "Error",
      customer_details_csv_import_feedback_success:
        "%s equipments created successfully.",
      customer_details_csv_import_feedback_partial:
        "%s equipments created, %s failed.",
      customer_details_csv_import_type_not_found_summary:
        "One or more types could not be found. Invalid rows will be skipped.",
      customer_details_csv_import_type_not_found_row:
        'Model "{type}" could not be found.',
      customer_details_csv_import_type_match: "Matched type",
      customer_details_csv_import_unknown_error: "Unknown error",
      customer_details_csv_import_error_min_rows:
        "CSV must include a header row and at least one data row.",
      customer_details_csv_import_error_header: "Invalid CSV header. Expected:",
      customer_details_csv_import_error_column_count:
        "Row {row}: expected {count} values.",
      customer_details_csv_import_error_required:
        "{field} is required.",
      customer_details_csv_import_error_row:
        "Row {row}: {message}",
      messages: "Messages",
      all_categories: "all categories",
      profile_settings: "Profile & Settings",
      add_machine_photo: "add machine photo",
      add_machine_typenameplate_photo: "machine typenameplate",
      add_user_photo: "add user photo",
      state_open: "open",
      state_closed: "closed",
      state_in_discussion: "in discussion",
      loading: "loading",
      access_denied: "Access Denied!",
      week: "week",
      month: "month",
      add_new_user: "add new user",
      first_name: "First Name",
      last_name: "Last Name",
      user_list: "User List",
      please_fill_name: "Please fill name field.",
      backLink: "Back",
      create_new_area: "Create New Area",
      area_name: "Area name",
      area_id: "Area ID",
      e_g_area_1: "e.g. Area 1",
      e_g_area_id: "e.g. 1233",
      button_create_area: "Create area",
      manage_machine_parks: "Manage machine parks",
      manage_machine_park: "Manage machine park",
      create_machine: "Create Machine",
      department: "Department (optional)",
      manufacturer_name: "Manufacturer name",
      e_g_casing_machining: "e.g. Casing Machining",
      internal_id: "ID",
      e_g_internal_id: "e.g. 5214",
      invetory_id: "Inventory ID",
      e_g_inventory_id: "e.g. 1234",
      memo_field: "Memo",
      enter_memo: "Enter note...",
      button_create_machine: "Create machine",
      create_equipment_pool: "Create Machine Park",
      equipment_pool_name: "Machine park name",
      equipment_pool_id: "Machine park ID",
      e_g_equipment_pool_id: "e.g. 1234",
      button_create_equipment_pool: "Create machine park",
      create_new_site: "Create New Size",
      site_name: "Site name",
      e_g_site_name: "e.g. Site 1",
      city: "City",
      e_g_city: "e.g. Birmingham",
      site_zip: "Site ZIP Code",
      e_g_site_zip: "e.g. B1 1DA",
      street: "Street",
      e_g_street: "e.g. Bristol St.",
      house_number: "House Number",
      e_g_house_number: "e.g. 8",
      site_id: "Site ID",
      e_g_site_id: "e.g. 1234",
      button_create_site: "Create site",
      statistics_since_initial_operation: "Statistics since Initial Operation",
      manufacturer_website: "Manufacturer web site",
      click_or_dragdrop: "Click or drag-and-drop",
      download: "Download",
      page: "Page",
      ofPage: "of",
      previous: "Previous",
      next: "Next",
      file_title: "File Title",
      file_description: "File description",
      upload_internal_file: "Upload Internal File",
      show_qr_code: "show QR code",
      show_type_plate: "show type plate",
      show_more_info: "show more info",
      all_areas: "all Areas",
      area_label: "Area",
      more_filter_sorting: "more Filters & Sorting",
      button_create_equipment: "Create equipment",
      typing: "typing…",
      write_a_message: "Write a message…",
      maintenance_empty_heading: "Routine Maintenance",
      maintenance_empty_title: "You have not planned any maintenance yet",
      maintenance_empty_description:
        "Routine maintenance is performed at regular intervals. All users registered for a machine receive a reminder to carry out the maintenance.",
      maintenance_table_title: "Title",
      maintenance_table_next_due: "Next execution",
      maintenance_table_repetition: "Repetition",
      maintenance_table_reminder: "Reminder",
      maintenance_table_category: "Category",
      counters_empty_heading: "Counters",
      counters_empty_title: "You have not created any counters for this machine yet",
      counters_empty_description:
        "Counters help you register and monitor important metrics such as operating hours.",
      counters_title: "Counters",
      counter_modal_title: "Create or edit counter",
      counter_new_type_placeholder: "Create new counter type...",
      counter_type_name_label: "Counter type name",
      counter_name_label: "Counter name",
      counter_value_label: "Counter value",
      counter_table_name: "Counter",
      counter_table_value: "Counter value",
      counter_table_updated: "Last updated",
      history_period_from_to: "Notifications from",
      rows_per_page: "rows per page",
      history_filter_closed: "Closed",
      role: "Role",
      phone_number_mobile: "Cellphone Number",
      phone_number_landline: "Landline Number",
      info_notification_status:
        "You automatically receive status updates for the machines assigned to you.",
      your_machines: "Your Machines",
      min_n_characters: "Minimum 8 characters",
      button_create_account: "Create Account",
      load_older_notifications: "load older notifications",
      tab_sites: "Sites",
      tab_admin: "Admin Area",
      area: "Area",
      area_heading: "Area",
      open_menu: "Open menu",
      corporate_email: "Corporate email address",
      //create client labels
      create_client_name: "Client Name",
      create_client_billinginformation: "Billing Information",
      create_client_licenseinformation: "License Information",
      create_client_legalentityname: "Legal Entity Name",
      create_client_domain: "Domain",
      create_client_address: "Address",
      tab_overview: "Overview",
      tab_discussion: "Discussion",
      heading_photos: "Photos",
      heading_videos: "Videos",
      button_upload_photo: "Upload photo",
      button_upload_video: "Upload video",
      button_upload_attachment: "Upload attachment",
      image_here: "Image here",
      none_uploaded: "None uploaded",
      empty_discussion: "So far, this issue was not discussed.",
      tab_history: "History",
      tab_documentation: "Documentation",
      tab_faq: "FAQ",
      tab_ecatalog: "eCatalog",
      tab_ecatalog_description:
        "Open the eCatalog website in a new tab to browse the product catalog.",
      tab_ecatalog_open: "Open eCatalog",
      tab_maintenance: "Maintenance",
      till_now: "Till now",
      create_site: "Create site",
      create_area: "Create area",
      all_sites: "all Sites",
      manufacturer: "Hersteller",
      internal_machine_name: "Internal Machine Name (optional)",
      heading_your_profile: "Your Profile",
      heading_safety: "Safety",
      additional_details: "Additional Details",
      photo: "Photo",
      add_solution: "Add Solution",
      workflow_step_desc: "Description",
      save_solution: "Save Solution",
      save_FAQ: "Save FAQ",
      workflow_title: "Workflow Title",
      no_workflow_title: "No Title",
      notification_solutions: "Notification Solutions",
      none_solution: "No Solution",
      edit_solution: "Edit Solution",
      internal_faqs: "Internal FAQs",
      manufacturer_faqs: "Manufacturer FAQs",
      update_faq: "EDIT",
      clear_faq: "DELETE",
      add_new_faq: "add new FAQ",
      add_faq: "Add FAQ",
      edit_faq: "Edit FAQ",
      faq_question: "Question",
      faq_answer: "Answer",
      maintenance: "Maintenance",
      new_maintenance: "New Maintenance",
      history_title: "Machine history",
      history_empty_title:
        "No notifications have been registered for this machine yet",
      history_description:
        "Here you can find all malfunctions, maintenance tasks, notes, etc. that have ever been documented for this machine in the system.",
      counter_desc:
        "Counters help you record and keep track of key figures such as operating hours.",
      new_maintenance_create: "Create new maintenance",
      maintenance_title: "Maintenance title",
      maintenance_title_helperText: 'e.g.: "Major Inspection"',
      maintenance_category: "Maintenance category",
      maintenance_category_manage: "Manage categories",
      maintenance_category_manage_title: "Manage maintenance categories",
      maintenance_category_new_title: "Create a new category",
      maintenance_category_title: "Category name",
      maintenance_category_title_helperText: 'e.g.: "ISO 45001"',
      maintenance_category_btn_save: "Create category",
      maintenance_category_delete: "Delete category",
      maintenance_category_edit: "Edit category",
      dropzone_dialog_title: "Drop file to upload",
      maintenance_date: "First appointment",
      maintenance_repetition: "Cycle of repetition",
      maintenance_reminder: "Reminder before appointment",
      maintenance_description: "Maintenance description",
      safty_instructions: "Safety instructions",
      safty_instructions_placeholder: "Enter safety instructions (optional)...",
      maintenance_create_btn: "Create maintenance",
      maintenance_update_btn: "Update maintenance",
      maintenance_trigger_label: "Maintenance trigger",
      maintenance_trigger_time: "Time-based",
      maintenance_trigger_counter: "Counter-based",
      maintenance_counter_label: "Counter",
      maintenance_repetition_cycle: "Repetition cycle",
      maintenance_latest_after: "At the latest after",
      maintenance_save_template: "Save maintenance as template",
      maintenance_repetition_yearly: "Yearly",
      maintenance_repetition_onetime: "One time",
      maintenance_repetition_oneweek: "One week",

      maintenance_repetition_twoweek: "Two weeks",

      maintenance_repetition_month: "Month",
      maintenance_repetition_months: "Months",
      maintenance_reminder_Week: "Week",
      maintenance_reminder_days: "Days",

      maintenance_reminder_Weeks: "Weeks",
      maintenance_reminder_month: "Month",
      maintenance_next_termine: "next appointment",
      maintenance_report: "Implementation Protocol",
      maintenance_report_empty:
        "There is still no record of a previous inspection.",
      maintenance_report_add_btn: "Create Report",
      protocol_executed: "Execution Date",
      protocol_title: "Create a protocol for implementation",
      protocol_comments: "Enter comment...",
      protocol_title_pretext: "Reported on",
      protocol_title_posttext: "of",
      protocol_description: "Summary",
      protocol_update: "Update Protocol",
      menu_Instandhaltung: "Maintenance",
      menu_Instandhaltung_submenu: "Notifications",

      menu_kunden_title: "Customer Management",
      menu_kunden_submenu:"Customers",
      menu_kunden_portal_submenu:"Customer portals",

      menu_Instandhaltung_submenu1: "Planned Maintenance",
      menu_Instandhaltung_submenu2: "Task planning",

      no_maintenancetask: "No Maintenancetask Available",
      edit_equipment: "Edit Equipment",
      edit: "Update",
      dropzone_dialog_title: "Drop file to upload",
      delete: "Delete",
      nav_machinetype: "Machine Type",
      nav_customermachines: "Customer Machines",
      nav_customermachines_allmachine: "All Machines",
      nav_customermachines_analysis: "Analysis",
      personal_number: "Personnel number (optional)",
      details_comment: "Enter qualifications (optional)...",
      specialization: "Fachausrichtung (optional)",
      nav_servicemanagement: "Service Management",
      nav_administration: "Administration",
      all_brands: "Alle Marken",
      brand: "Marken",
      create_equipment_type: "Create Equipment Type",
      update_equipment_type: "Update Equipment Type",
      delete_equipment_type: "Delete Equipment Type",
      create_brand: "Create Brand",
      update_brand: "Update Brand",
      delete_brand: "Delete Brand",
      create_equipment_class: "Create Equipment Class",
      update_equipment_class: "Update Equipment Class",
      delete_equipment_class: "Delete Equipment Class",
      customer_equipments: "Customer Equipments",
      customer_contact: "Customer Contact",

      history_filter_created: "Created",
      history_filter_closed: "Closed",
      history_filter_type: "Type",
      history_filter_status: "Status",
      history_filter_keyword: "Keyword",
      history_filter_reset: "Reset",
      history_filter_export: "Export Selection",
      history_filter_actions: "Actions",
      systemCreated: "System Created",
      allMachines: "All Equipments",
      allMachinePools: "All Equipment Pools",
      allSites: "All Sites",
      no_open_notification: "No open notifications",

      no_data: "No Data",
      admin_search_placeholder: "Search users",

      admin_scope_header_0: "Administration",
      admin_scope_header_desc_0:
        "Here you manage your subscription and all users.",

      admin_scope_header_1: "Administration",
      admin_scope_header_desc_1: "Here you manage all users.",
      backToLogin: "Back to Login",
    },

    // German language
    de: {
      dropzone_dialog_title: "Datei fallen lassen, um hochzuladen",

      change_password: "Kennwort ändern",
      update_user: "Benutzer bearbeiten",
      year: "Jahr",

      admin_search_placeholder: "Benutzer durchsuchen",
      dropzone_dialog_title: "Datei fallen lassen, um hochzuladen",
      no_data: "Keine Daten",

      menu_kunden_title: "Customer Management",
      menu_kunden_submenu:"Customers",
      menu_kunden_portal_submenu:"Customer portals",
      
      admin_scope_header_0: "Administration",
      admin_scope_header_desc_0:
        "Here you manage your subscription and all users.",

      admin_scope_header_1: "Administration",
      admin_scope_header_desc_1: "Here you manage all users.",
      scopeHeader: {
        dashboardTitle: "Dashboard",
        dashboardDescription:
          "Das Dashboard zeigt Ihnen auf, welche Ihrer Equipments Auffälligkeiten aufweisen, damit Sie umgehend darauf reagieren können.",
        sparePartsTitle: "Ersatzteile",
        sparePartsDescription: "Verwaltung und Übersicht der Ersatzteile.",
        trainingTitle: "Schulungen",
        trainingDescription: "Verwaltung und Übersicht von Schulungen.",
        customerTrainingsTitle: "Kundentrainings",
        customerTrainingsDescription:
          "Hier finden Sie die Inhalte des globalen Trainingsprogramms. Sie können nur die Module öffnen, die von Ihnen gebucht wurden.",
        customersTitle: "Kunden",
        customersDescription:
          "Verwalten Sie Kundenstammdaten inklusive der beim Kunden eingesetzten Werke und Maschinen.",
        customerPortalsTitle: "Kundenportale",
        customerPortalsDescription:
          "Konfigurieren Sie die Online-Portale Ihrer Kunden und passen Sie die Anzeigeeinstellungen an.",
        productTypesTitle: "Produkttypen",
        productTypesDescription:
          "Verwalten Sie produktspezifische Inhalte wie Dokumente und FAQs für Produkttypen von Maschinenbauern.",
        equipmentTitle: "Equipment",
        equipmentDescription:
          "Verwalten Sie Equipment-Pools und die zugeordneten Equipments.",
        exportTitle: "Export",
        exportDescription:
          "Exportieren Sie gespeicherte 247UpTime-Daten wie Meldungen und Zählerwerte.",
        openNotificationsTitle: "Offene Meldungen",
        openNotificationsDescription:
          "Erhalten Sie einen Überblick über aktuelle Vorfälle oder erstellen Sie neue Meldungen für Ihr Team.",
        sitesTitle: "Werke",
        sitesDescription: "Verwalten Sie Ihre Werke und die zugehörigen Bereiche.",
        maintenanceTitle: "Geplante Wartung",
        maintenanceDescription:
          "Planen und verfolgen Sie wiederkehrende Wartungen und Inspektionen.",
        taskPlanningTitle: "Aufgabenplanung",
        taskPlanningDescription:
          "Weisen Sie offene Meldungen Teammitgliedern zu und behalten Sie den Überblick.",
        helpFeedbackTitle: "Hilfe & Feedback",
        helpFeedbackDescription:
          "Informieren Sie sich über die 247UpTime-Funktionen oder senden Sie Feedback zur Software.",
        sparePartsPlaceholder: "Der Ersatzteilbereich ist vorbereitet.",
        trainingPlaceholder: "Der Schulungsbereich ist vorbereitet.",
        customerTrainingsPlaceholder: "Der Kundentrainingsbereich ist vorbereitet.",
      },

      user_table_status: "status",
      user_table_Vorname: "Vorname",
      user_table_Nachname: "Nachname",
      user_table_Benutzertyp: "Benutzertyp",
      user_table_email: "E-Mail-Adresse",

      land_germany_name: "Deutschland",
      land_germany_value: "en",

      land_austria_name: "Österreich",
      land_austria_value: "en",

      land_swiss_name: "schweizerisch",
      land_swiss_value: "en",

      land_checkrepulic_name: "czeckreuplic",
      land_checkrepublic_value: "en",

      land_poland_name: "Polen",
      land_poland_value: "de",

      create_site_title: "Neues Werk anlegen",
      update_site_title: "Werk bearbeiten",

      create_area_title: "Neuen Bereich anlegen",
      update_area_title: "Bereich bearbeiten",

      create_equipment_title: "Neues Equipment anlegen",

      dashboard_initial_factory_title: "Werke und Bereiche anlegen",
      dashboard_initial_equipment_title: "Equipment Pools anlegen",
      dashboard_initial_users_title: "Weitere 247UpTime-Benutzer erstellen",
      dashboard_initial_final_title: "Equipment anlegen und zuordnen",
      no_time_range_selected: "Kein Zeitraum gewählt",
      backToLogin: "Zurück zum Anmelden",
      dashboard_initial_factory_tooltip: "Definieren Sie ihre lokale Struktur aus Werken und Bereichen",
      dashboard_initial_equipment_tooltip: "Definieren Sie ihre logische Struktur aus Pools",
      dashboard_initial_users_tooltip: "Fügen Sie weitere Nutzer hinzu",
      dashboard_initial_final_tooltip:
        "Equipments können Sie erst anlegen, wenn Sie mindestens ein Werk/Bereich oder einen Pool angelegt haben, welchem das Equipment zugeordnet wird.",
      dashboard_empty_open_notifications:
        "Im gewählten Zeitraum liegen keine offenen Meldungen vor.",
      dashboard_empty_welcome:
        "Herzlich willkommen bei %s! Es wurden noch keine Equipments hinzugefügt. Bitte öffnen Sie hierzu Ihr Nutzer-Profil.",
      dashboard_kpi_mtbf: "MTBF",
      dashboard_kpi_mtbf_tooltip: "MTBF = Betriebsstunden / Anzahl ungeplanter Stillstände",
      dashboard_kpi_maintenance_done: "Wartungen durchgeführt",
      dashboard_kpi_maintenance_done_tooltip:
        "Geplante Wartungen (erledigt) / Geplante Wartungen (insges.)",
      dashboard_kpi_unplanned_downtimes: "Ungeplante Stillstände",
      dashboard_kpi_unplanned_downtimes_tooltip:
        "Alle ungeplanten Stillstände der letzten 12 Monate",
      dashboard_kpi_total_range: "Zeitraum (gesamt)",
      dashboard_kpi_last_12_months: "letzte 12 Monate",

      dashboard_initial_state_title:
        "Guten Tag, %s!<br> Fahren Sie mit der Einrichtung von 247UpTime fort.",
      dashboard_initial_state_description:
        "Sie können nach der erstmaligen Einrichtung jederzeit weitere Werke, Equipment und Benutzer erstellen.",

      construction_year: "Baujahr",
      carry_now: "jetzt durchführen",
      empty_dashboard_button: "Profil & Einstellungen öffnen",
      empty_dashboard_title: "Sie haben noch keine Maschinen abonniert",
      empty_dashboard_desc:
        "Um Maschinen zu abonnieren, müssen Sie in Ihrem Benutzerprofil im Bereich „Ihre Maschinen“ die für Sie relevanten Werke oder Maschinenpools auswählen.",
      footer_contact: "Kontakt",
      footer_data_protection: "Datenschutz",
      footer_impressum: "Impressum",
      equipment_serial_number: "Seriennummer",
      counter_Type: "Zählertyp",
      sites: "Werke",
      export_machine_details: "Export Ihrer Daten",
      no_notifications:
        "Keine neuen Benachrichtigungen. Wir benachrichtigen Sie, sobald es neue Vorfälle gibt.",
      add_new_counter: "NEU",
      new_badge: "NEU",
      tab_counters: "Zähler",
      streetnumber: "Straße",
      postalCode: "Postleitzahl",
      city: "Stadt",
      land: "Land",
      reported: "Gemeldet",
      firmName: "Firmenname",
      homePage: "Startseite",
      firm_details: "DETAILS ZU IHRER FIRMA",
      email: "E-Mail-Adresse",
      password: "Passwort",
      forgot_password: "Passwort vergessen?",
      loginHeading: "Login zum Kundenportal",
      loginButton: "Einloggen",
      registration: "Registrieren",
      no_account: "SIE HABEN NOCH KEINEN ACCOUNT?",
      required_field: "Pflichtfeld",
      register_for_free: "Kostenfrei registrieren",
      searchplaceholder_tablet: "Suchen nach Maschinen, Meldungen, …",
      searchplaceholder_phone: "Suchen nach Maschinen, Meldungen, …",
      createnewissue: "Neue Meldung erstellen",
      update_notification: "Meldung Bearbeiten",
      opennotifications: "Offene Meldungen",
      machineparks: "Maschinenparks",
      machinepark: "Maschinenpark",
      all_machineparks: "Alle Equipment Pools",
      factorysections: "Werksabschnitte",
      machinecategory: "Maschinenkategorie",
      machinestatus: "Maschinenstatus",
      groupby: "Gruppieren nach",
      timerange: "Zeitraum",
      show_n_more: "%s weitere anzeigen",
      show_less: "Weniger anzeigen",
      no_notifications:
        "Keine neuen Benachrichtigungen. Wir benachrichtigen Sie, sobald es neue Vorfälle gibt.",
      add_new_counter: "NEU",

      add_new_kunden: "neuen Kunden anlegen",
      streetnumber: "Straße",
      postalCode: "Postleitzahl",
      city: "Stadt",
      land: "Land",
      reported: "Gemeldet",
      firmName: "Firmenname",
      homePage: "Startseite",
      firm_details: "DETAILS ZU IHRER FIRMA",
      email: "E-Mail-Adresse *",
      password: "Passwort",
      forgot_password: "Passwort vergessen?",
      loginHeading: "Login zum Kundenportal",
      loginButton: "Einloggen",
      trialButton: "30 Tage Kostenfrei Testen",
      companyName: "Unternehmen",
      signUpHeading: "Neuen Account erstellen",
      signUpHeading2:
        "Nur noch ein Schritt, um Ihre Registrierung abzuschließen",
      createAccount: "Account Erstellen",
      toLogin: "Zum Login",
      businessEmail: "Geschäfliche E-Mail-Adresse",
      registration: "Registrieren",
      no_account: "SIE HABEN NOCH KEINEN ACCOUNT?",
      required_field: "Pflichtfeld",
      register_for_free: "Kostenfrei registrieren",
      searchplaceholder_tablet: "Suchen nach Maschinen, Meldungen, …",
      searchplaceholder_phone: "Suchen nach Maschinen, Meldungen, …",
      createnewissue: "Neue Meldung erstellen",
      update_notification: "Meldung Bearbeiten",
      opennotifications: "Offene Meldungen",
      machineparks: "Maschinenparks",
      machinepark: "Maschinenpark",
      all_machineparks: "Alle Equipment Pools",
      factorysections: "Werksabschnitte",
      machinecategory: "Maschinenkategorie",
      machinestatus: "Maschinenstatus",
      groupby: "Gruppieren nach",
      timerange: "Zeitraum",
      show_n_more: "%s weitere anzeigen",
      show_less: "Weniger anzeigen",
      //empty_notifications: 'Es gibt derzeit keine ungelösten Probleme. Weiter so!',
      empty_notifications: "derzeit keine",
      notification_singular: "Meldung",
      notification_plural: "Meldungen",
      //avg_solutiontime: 'Ø Maßnahmeszeit',
      avg_solutiontime: "MTTR",
      incidents: "Störfälle",
      statistics: "Statistiken",
      new_issue: "Neue Meldung",
      create_new_notification: "Neue Meldung erstellen",
      save_notification: "Speichern",
      save: "Speichern",
      next_appointment: "Nächster Termin",
      due_on: "Fällig am",
      rotation: "Turnus",
      filter_sorting: "Filter & Sortierung",
      filter: "Filter",
      sorting: "Sortierung",
      unresolved: "ungelöst",
      day: "Tag",
      days: "Tage",
      empty_machineparks:
        "Es sind noch keine Maschinenparks eingerichtet worden. Wenden Sie sich bitte an den Administrator.",
      undisturbed: "störungsfrei",
      disturbed: "Störung",
      tab_dashboard: "Dashboard",
      tab_machineparks: "Maschinenparks",
      tab_messages: "Nachrichten",
      super_tab_clients: "Kunden",
      super_tab_users: "Benutzer",
      super_tab_brands: "Marken",
      super_tab_equipment_types: "Gerätetypen",
      tab_notifications: "Mitteilungen",

      manufacturer_serial_number: "Hersteller-Seriennummer",
      heading_latest_notifications: "Aktuelle Meldungen & geplante Wartungen",
      go_to_machine_history: "Zur Maschinenhistorie",
      heading_responsible: "Verantwortlich",
      heading_manufacturer_service: "Hersteller-Service",
      heading_life_cycle: "Lebenslauf",
      notificationtype: "Meldungstyp",
      built_year: "Baujahr",
      empty_history:
        "Die Maschinenhistorie weißt bisher noch keine Meldungen auf.",
      today: "Heute",
      heading_documentation: "Dokumentation",
      file_powerpoint: "PowerPoint",
      file_excel: "Excel",
      file_word: "Word",
      file_email: "Email",
      file_word_macro: "Word (Macro)",
      file_odt: "ODT Dokument",
      file_ods: "ODS Spreadsheet",
      file_image: "Bild",
      file_audio: "Audio",
      file_video: "Video",
      file_url: "Link",
      hasinternalattachment: "Interne Ressourcen",
      hasmanufacturerattchment: "Hersteller Ressourcen",
      add_new_resource: "neue Ressource hinzufügen",
      add_ressource: "Ressource hinzufügen",
      upload_file: "Datei hochladen",
      resource_vendor: "Zuordnung",
      resource_type: "Typ",
      resource_type_file: "Datei",
      resource_type_link: "Link",
      resource_type_photo: "Foto",
      resource_type_video: "Video",
      resource_url: "Link (URL)",
      change_file: "Datei ändern",
      resource_name: "Titel der Ressource",
      resource_description: "Beschreibung (optional)",
      resource_language: "Sprache",
      resource_scope: "Gültigkeitsbereich",
      button_cancel: "abbrechen",
      button_yes: "Ja",
      button_no: "Nein",
      upload_attachment_title_upload: "Datei hochladen",
      upload_attachment_title_edit: "Datei bearbeiten",
      upload_attachment_choose_file: "Datei auswählen...",
      upload_attachment_allowed_types:
        "Es sind nur Text-, PDF-, Word- und Excel-Dateien zulässig!",
      upload_attachment_display_name: "Anzeigename",
      upload_attachment_short_description: "Kurzbeschreibung (optional)",
      upload_attachment_category: "Kategorie",
      upload_attachment_invalid_extension: "Ungültige Dateierweiterung!",
      empty_resources:
        "Bisher wurden dieser Maschine noch keine Ressourcen hinzugefügt.",
      button_done: "Fertig",
      select_multiple_n: "mehrere (%s)",
      header_data: "Kopfdaten",
      referred_to_machine: "Betreffende Maschine",
      notification_title: "Titel der Meldung",
      helpertext_notification_title: 'z. B.: "Hauptspindel defekt"',
      referred_to_assembly: "Betroffene Baugruppe",
      date: "Datum",
      time: "Zeit",
      notification_share_title: "Meldung teilen",
      notification_share_email_prompt: "Bitte geben Sie den Email-Empfänger ein",
      notification_share_email_label: "Email",
      notification_share_send: "Senden",
      notification_share_inline: "per E-Mail teilen",
      notification_delete: "Meldung löschen",
      notification_safety_notes: "Sicherheitshinweise",
      notification_error_code: "Fehlercode",
      problem_solution_status: "Status",
      notification_description: "Beschreibung",
      error_code: "Fehlercode (optional)",
      describe_notification: "Beschreiben Sie die Meldung…",
      docs_empty_title: "Sie haben noch keine Dateien in dieser Kategorie hochgeladen",
      docs_empty_hint:
        "Laden Sie eine Datei hoch. Tipp: Sie können auch mehrere Dateien gleichzeitig per Drag und Drop hochladen.",
      add_photos_videos: "Fotos/Videos hinzufügen",
      capture_photo: "Neues Foto aufnehmen",
      capture_video: "Neues Video aufnehmen",
      add_from_gallery: "Von Galerie hinzufügen",
      add_attachments: "Anhänge hinzufügen",
      enter_description: "Beschreibung eingeben…",
      change_attachments: "Anhänge ändern",
      notification_sucessfully_created: "Die Meldung wurde erfolgreich erfasst",
      discuss_notification: "Meldung besprechen",
      go_to_machine: "zur Maschine",
      notificationtype_from: "%notificationtype vom %datetime",
      reported_by: "gemeldet durch",
      machine: "Maschine",
      images: "Bilder",
      no_images_yet: "Dieser Meldung wurden noch keine Bilder hinzugefügt.",
      attachments: "Anhänge",
      edit_notification: "Meldung bearbeiten",
      notification_solved: "Die Meldung wurde erfolgreich gelöst.",
      close_notification_heading: "Meldung schließen",
      close_notification_text:
        "Möchten Sie die Meldung als gelöst kennzeichen und alle Beteiligten Instanzen darüber informieren?",
      settings: "Einstellungen",
      chat_notifications: "Chat-Benachrichtigungen",
      automatic_translation: "Automatische Übersetzung",
      activate: "aktivieren",
      target_language: "Zielsprache",
      involved_contacts_heading: "Beteiligte Kontakte",
      search_contacts: "Kontakte suchen…",
      empty_discussion_contacts:
        "Dieser Diskussion wurden noch keine Kontakte hinzugefügt.",
      discussion_heading: "Diskussion",
      error_chatroom_loading: "Der Chatraum konnte nicht geladen werden.",
      error_email_required: "Bitte E-Mail-Adresse eingeben",
      error_email_format: "Eingegebene E-Mail-Adresse ist ungültig",
      error_password_required: "Bitte Passwort eingeben",
      error_password_wrong: "E-Mail und Passwort stimmen nicht überein.",
      enter_message: "Nachricht eingeben…",
      time_h: "Uhr",
      alert_trash_changes_body:
        "Möchten Sie die von Ihnen vorgenommenen Änderungen verwerfen?",
      button_save_changes: "Änderungen speichern",
      logout: "Logout",
      product_types_back: "Produkttypen",
      product_types_title: "Produkttyp erstellen",
      product_types_description:
        "Ihre Produkttypen sind die Basis für die bei Ihren Kunden eingesetzten Maschinen. Durch Produkttypen können Sie produktspezifische Inhalte wie Dokumente und FAQs zentral an einer Stelle verwalten und Ihren Kunden bereitstellen.",
      product_types_footer_button: "Produkttyp erstellen",
      product_types_tab_overview: "Übersicht",
      product_types_tab_documents: "Dokumente",
      product_types_tab_faq: "FAQ",
      product_types_tab_maintenance_plan: "Wartungsplan",
      product_types_tab_updates: "Updates",
      product_types_master_data: "Stammdaten",
      product_types_brand: "Markenname",
      product_types_product_class: "Produktklasse",
      product_types_type_name: "Typbezeichnung",
      product_types_faq_title: "Häufige Fragen und Antworten",
      product_types_faq_empty_title: "Sie haben noch keine FAQ hinterlegt",
      product_types_faq_empty_description:
        "Hinterlegen Sie häufige Fragen und Antworten, um Supportanfragen zu minimieren und bestehendes Wissen zu dokumentieren.",
      product_types_faq_empty_action: "Neue FAQ",
      product_types_faq_add_action: "FAQ hinzufügen",
      product_types_faq_edit_action: "Bearbeiten",
      product_types_faq_delete_action: "Löschen",
      product_types_faq_save_action: "Speichern",
      product_types_faq_question_label: "Frage",
      product_types_faq_answer_label: "Antwort",
      product_types_version: "Version",
      product_types_date_range: "Zeitraum",
      product_types_date_range_from: "Von",
      product_types_date_range_to: "Bis",
      product_types_date_range_apply: "Übernehmen",
      product_types_helper_type: "z.B.: P3000",
      product_types_helper_product_class: "z.B.: Maschine, Werkzeug, etc.",
      product_types_internal_notes: "Interne Notizen",
      product_types_internal_notes_helper: "Nicht für Ihre Kunden sichtbar",
      product_types_title_list: "Produkttypen",
      product_types_new_button: "Neu",
      product_types_search_placeholder: "Produkttypen durchsuchen",
      product_types_filter_button: "Filter",
      product_types_filter_brand: "Marke",
      product_types_filter_product_class: "Produktklasse",
      product_types_filter_equipment_class: "Produktklasse",
      product_types_filter_machine_class: "Maschinenklasse",
      product_types_header_type: "Typbezeichnung",
      product_types_header_brand: "Marke",
      product_types_header_product_class: "Produktklasse",
      product_types_header_equipment_class: "Produktklasse",
      product_types_entries_per_page: "%s Einträge pro Seite",
      product_types_all: "alle",
      product_types_empty_title: "Sie haben noch keine Produkttypen angelegt",
      product_types_empty_description: "Legen Sie jetzt Ihren ersten Produkttyp an.",
      product_types_empty_action: "Neuen Produkttyp anlegen",
      product_types_placeholder_body:
        "Diese Ansicht folgt als Nächstes. Wir nutzen hier die gleiche Typografie und Seitenstruktur wie im restlichen Produkttyp-Bereich.",
      product_types_docs_title: "Produktspezifische Dokumente",
      product_types_docs_upload: "DATEI HOCHLADEN",
      product_types_docs_empty_title:
        "Sie haben noch keine Dateien in dieser Kategorie hochgeladen",
      product_types_docs_empty_hint:
        "Laden Sie eine Datei hoch. Tipp: Sie können auch mehrere Dateien gleichzeitig hochladen.",
      product_types_docs_empty_action: "DATEI HOCHLADEN",
      product_types_docs_file: "Datei",
      product_types_docs_uploading: "Dateien werden hochgeladen",
      product_types_docs_dropzone_title: "Dateien hier ablegen",
      product_types_docs_drop_hint:
        "Lassen Sie die Datei los, um sie dieser Produkttyp-Kategorie zuzuordnen.",
      product_types_docs_category_operation: "Bedienen und Einrichten",
      product_types_docs_category_setup: "Rüsten",
      product_types_docs_category_maintenance: "Wartung und Service",
      product_types_docs_category_safety: "Sicherheit",
      product_types_docs_category_internal: "Interne Anweisungen",
      all_notificationtypes: "alle Meldungstypen",
      notificationtype_malfunction: "Störungen",
      notificationtype_abnormality: "Auffälligkeit",
      notificationtype_memo: "Notizen",
      notificationtype_task: "Aufgabe",
      notificationtype_internal_message: "Interne Mitteilungen",
      notificationtype_manufacturer_message: "Herstellermitteilung",
      notificationtype_planned_maintenance: "Geplante Wartungen",
      notificationtype_maintenance: "Wartungen",
      avg_uptime: "Uptime",
      search_result: { sng: "Suchergebnis", plr: "Suchergebnisse" },
      documents: "Dokumente",
      machines: "Maschinen",
      customer_details_csv_selected: "CSV-Datei ausgewählt.",
      customer_details_csv_invalid: "Bitte wählen Sie eine CSV-Datei aus.",
      customer_details_csv_import_title: "CSV-Import",
      customer_details_csv_import_drop_title: "CSV-Datei importieren",
      customer_details_csv_import_drop_description:
        "Legen Sie Ihre CSV-Datei hier ab oder klicken Sie zum Auswählen. Wir prüfen die feste Kopfzeile, zeigen die Daten in einer Vorschau und legen die Maschinen dann in diesem Equipment Pool an.",
      customer_details_csv_import_create: "Maschinen anlegen",
      customer_details_csv_import_cancel: "Abbrechen",
      customer_details_csv_import_success: "Alle CSV-Zeilen wurden erfolgreich angelegt.",
      customer_details_csv_import_progress: "Maschinen werden angelegt...",
      customer_details_csv_import_rows: "Zeilen",
      customer_details_csv_import_created: "angelegt",
      customer_details_csv_import_failed: "fehlgeschlagen",
      customer_details_csv_import_status_ready: "Bereit",
      customer_details_csv_import_status_success: "Erfolgreich",
      customer_details_csv_import_status_error: "Fehler",
      customer_details_csv_import_feedback_success:
        "%s Maschinen wurden erfolgreich angelegt.",
      customer_details_csv_import_feedback_partial:
        "%s Maschinen angelegt, %s fehlgeschlagen.",
      customer_details_csv_import_type_not_found_summary:
        "Ein oder mehrere Typen konnten nicht gefunden werden. Ungültige Zeilen werden übersprungen.",
      customer_details_csv_import_type_not_found_row:
        'Model "{type}" konnte nicht gefunden werden.',
      customer_details_csv_import_type_match: "Gefundener Typ",
      customer_details_csv_import_unknown_error: "Unbekannter Fehler",
      customer_details_csv_import_error_min_rows:
        "Die CSV muss eine Kopfzeile und mindestens eine Datenzeile enthalten.",
      customer_details_csv_import_error_header:
        "Ungültige CSV-Kopfzeile. Erwartet:",
      customer_details_csv_import_error_column_count:
        "Zeile {row}: {count} Werte erwartet.",
      customer_details_csv_import_error_required:
        "{field} ist erforderlich.",
      customer_details_csv_import_error_row:
        "Zeile {row}: {message}",
      messages: "Nachrichten",
      all_categories: "alle Kategorien",
      profile_settings: "Profil & Einstellungen",
      add_machine_photo: "Maschinenfoto hinzufügen",
      add_machine_typenameplate_photo: "Typenschild der Maschine",
      add_user_photo: "Benutzerbild hinzufügen",
      state_open: "offen",
      state_closed: "erledigt",
      state_in_discussion: "in Bearbeitung",
      loading: "Wird geladen",
      access_denied: "Zugriff verwehrt!",
      week: "Woche",
      month: "Monat",
      add_new_user: "Neuen Benutzer hinzufügen",
      first_name: "Vorname",
      last_name: "Nachname",
      user_list: "Benutzerliste",
      please_fill_name: "Bitte vergeben Sie einen Namen.",
      backLink: "Zurück",
      create_new_area: "Neuen Werksabschnitt erstellen",
      area_name: "Werksabschnittsname",
      area_id: "ID des Werksabschnitts",
      e_g_area_1: "z. B. Werk 1",
      e_g_area_id: "z. B. 1233",
      button_create_area: "Abschnitt erstellen",
      manage_machine_parks: "Maschinenparks verwalten",
      manage_machine_park: "Maschinenpark verwalten",
      create_machine: "Maschine anlegen",
      department: "Abteilung (optional)",
      cost_center: "Kostenstelle (optional)",
      manufacturer_name: "Herstellerbezeichnung",
      e_g_casing_machining: "z. B. Gehäusebearbeitung",
      internal_id: "Identifikationsnummer",
      e_g_internal_id: "z. B. 5214",
      invetory_id: "Inventar ID",
      e_g_inventory_id: "z. B. 1234",
      memo_field: "Notizen",
      enter_memo: "Notiz eingeben...",
      button_create_machine: "Maschine anlegen",
      create_equipment_pool: "Maschinenpark anlegen",
      equipment_pool_name: "Name des Maschinenparks",
      equipment_pool_id: "ID des Maschinenparks",
      e_g_equipment_pool_id: "z. B. 1234",
      button_create_equipment_pool: "Maschinenpark anlegen",
      create_new_site: "Neues Werk anlegen",
      site_name: "Name des Werkes",
      e_g_site_name: "z. B. Werk 1",
      city: "Ort",
      e_g_city: "z. B. Ingolstadt",
      site_zip: "Postleitzahl des Werkes",
      e_g_site_zip: "z. B. 85053",
      street: "Straße",
      e_g_street: "z. B. Münchner Straße",
      house_number: "Hausnummer",
      e_g_house_number: "z. B. 8",
      site_id: "ID des Werkes",
      e_g_site_id: "z. B. 1234",
      button_create_site: "Werk anlegen",
      statistics_since_initial_operation: "Statistik seit Inbetriebnahme",
      manufacturer_website: "Hersteller-Webseite",
      click_or_dragdrop: "Klicken oder Drag-and-Drop",
      download: "Download",
      page: "Seite",
      ofPage: "von",
      previous: "Zurück",
      next: "Weiter",
      file_title: "Dateititel",
      file_description: "Beschreibung",
      upload_internal_file: "Interne Datei hochladen",
      show_qr_code: "QR-Code anzeigen",
      show_type_plate: "Typenschild anzeigen",
      show_more_info: "mehr Infos anzeigen",
      all_areas: "Alle Bereiche",
      area_label: "Bereich",
      more_filter_sorting: "mehr Filter & Sortierung",
      button_create_equipment: "Maschine erstellen",
      typing: "schreibt…",
      write_a_message: "Schreiben Sie eine Nachricht…",
      maintenance_empty_heading: "Routinewartungen",
      maintenance_empty_title: "Sie haben noch keine Wartungen geplant",
      maintenance_empty_description:
        "Routinewartungen werden in regelmäßigen Intervallen ausgeführt. Alle für eine Maschine registrierten User erhalten eine Erinnerung zur Ausführung der Wartung.",
      maintenance_table_title: "Titel",
      maintenance_table_next_due: "Nächste Durchführung",
      maintenance_table_repetition: "Wiederholung",
      maintenance_table_reminder: "Erinnerung",
      maintenance_table_category: "Kategorie",
      counters_empty_heading: "Zähler",
      counters_empty_title: "Sie haben noch keine Zähler für diese Maschine erstellt",
      counters_empty_description:
        "Zähler helfen Ihnen dabei, wichtige Kennzahlen wie zum Beispiel Betriebsstunden zu registrieren und im Blick zu behalten.",
      counters_title: "Zähler",
      counter_modal_title: "Zähler bearbeiten oder anlegen",
      counter_new_type_placeholder: "Neuen Zählertyp anlegen...",
      counter_type_name_label: "Name des Zählertyps",
      counter_name_label: "Zählerbezeichnung",
      counter_value_label: "Zählerstand",
      counter_table_name: "Zähler",
      counter_table_value: "Zählerstand",
      counter_table_updated: "Zuletzt aktualisiert",
      history_period_from_to: "Meldungen vom",
      rows_per_page: "Zeilen pro Seite",
      role: "Rolle",
      phone_number_mobile: "Handynummer",
      phone_number_landline: "Festnetz",
      info_notification_status:
        "Sie erhalten automatisch Statusupdates für die für Sie zugewiesenen Maschinen.",
      your_machines: "Ihre Maschinen",
      min_n_characters: "Mindestens 8 Zeichen",
      button_create_account: "Account erstellen",
      load_older_notifications: "ältere laden",
      tab_sites: "Werke",
      tab_admin: "Adminbereich",
      area: "Werksabschnitt",
      area_heading: "Werksabschnitt",
      open_menu: "Menü öffnen",
      corporate_email: "Unternehmens-E-Mail-Adresse",
      //create client labels
      create_client_name: "Kundenname",
      create_client_billinginformation: "Abrechnungsdaten",
      create_client_licenseinformation: "Lizenzinformationen",
      create_client_legalentityname: "Offizielle Unternehmensbezeichnung",
      create_client_domain: "Domain",
      create_client_address: "Adresse",
      tab_overview: "Übersicht",
      tab_discussion: "Diskussion",
      heading_photos: "Fotos",
      heading_videos: "Videos",
      button_upload_photo: "Foto hochladen",
      button_upload_video: "Video hochladen",
      button_upload_attachment: "Anhang hochladen",
      image_here: "Bild hier",
      none_uploaded: "Keine hochgeladen",
      empty_discussion: "Bisher wurde diese Meldung noch nicht diskutiert.",
      tab_history: "Historie",
      tab_documentation: "Dokumentation",
      tab_faq: "FAQ",
      tab_ecatalog: "eCatalog",
      tab_ecatalog_description:
        "Öffnen Sie die eCatalog-Website in einem neuen Tab, um den Produktkatalog zu durchsuchen.",
      tab_ecatalog_open: "eCatalog öffnen",
      tab_maintenance: "Wartungen",
      till_now: "Bis jetzt",
      create_site: "Werk erstellen",
      create_area: "Werksabschnitt erstellen",
      all_sites: "alle Werke",
      manufacturer: "Hersteller",
      internal_machine_name: "Interner Maschinenname (optional)",
      heading_your_profile: "Ihr Profil",
      heading_safety: "Sicherheit",
      additional_details: "Zusätzliche Details",
      photo: "Foto",
      add_solution: "Maßnahme Hinzufügen",
      workflow_step_desc: "Beschreibung",
      save_solution: "Maßnahme Speichern",
      workflow_title: "Workflow-Titel",
      no_workflow_title: "Kein Titel",
      notification_solutions: "Vorgehensbeschreibung",
      none_solution: "Keine Maßnahme",
      edit_solution: "Maßnahme Bearbeiten",
      internal_faqs: "Intern FAQs",
      manufacturer_faqs: "Hersteller FAQs",
      update_faq: "BEARBEITEN",
      clear_faq: "LÖESCHEN",
      add_new_faq: "neue FAQ",
      add_faq: "FAQ hinzufügen",
      edit_faq: "FAQ bearbeiten",
      faq_question: "Frage",
      faq_answer: "Anwort",
      save_FAQ: "FAQ speichern",
      maintenance: "Routinewartungen",
      new_maintenance: "Neue Wartung",
      history_title: "Maschinenhistorie",
      history_empty_title:
        "Für diese Maschine wurden noch keine Meldungen registriert",
      history_empty_description:
        "Hier finden Sie alle Störungen, Wartungen, Notizen, etc., die jemals für diese Maschine im System dokumentiert worden sind.",
      history_description:
        "Hier finden Sie alle Störungen, Wartungen, Notizen, etc., die jemals für diese Maschine im System dokumentiert worden sind.",
      maintenance_desc:
        "Routinewartungen werden in regelmäßigen Intervallen ausgeführt. Alle für eine Maschine registrierten User erhalten eine Erinnerung zur Ausführung der Wartung.",
      counter_desc:
        "Zähler helfen Ihnen dabei,  wichtige Kennzahlen wie zum Beispiel Betriebsstunden zu registrieren und im Blick zu behalten.",
      new_maintenance_create: "Neue Wartung erstellen",
      maintenance_title: "Titel der Wartung",
      maintenance_title_helperText: "z.B.: “Große Inspektion”",
      maintenance_category: "Kategorie der Wartung",
      maintenance_category_manage: "Kategorien verwalten",
      maintenance_category_manage_title: "Wartungs-Kategorien verwalten",
      maintenance_category_new_title: "Neue Kategorie anlegen",
      maintenance_category_title: "Name der Kategorie",
      maintenance_category_title_helperText: "z.B.: “ISO “45001",
      maintenance_category_btn_save: "Kategorie anlegen",
      maintenance_category_delete: "Kategorie löschen",
      maintenance_category_edit: "Kategorie editieren",
      maintenance_date: "Erster Termin",
      maintenance_repetition: "Turnus der Wiederholung",
      maintenance_reminder: "Erinnerung vor Termin",
      safty_instructions_placeholder:
        "Sicherheitshinweise (optional) eingeben...",
      maintenance_description: "Beschreibung der Wartung",
      safty_instructions: "Sicherheitshinweise",
      maintenance_create_btn: "Wartung erstellen",
      maintenance_update_btn: "SPEICHERN",
      maintenance_trigger_label: "Auslöser für Wartung",
      maintenance_trigger_time: "Zeit-basiert",
      maintenance_trigger_counter: "Zähler-basiert",
      maintenance_counter_label: "Zähler",
      maintenance_repetition_cycle: "Turnus der Wiederholung",
      maintenance_latest_after: "Spätestens nach",
      maintenance_save_template: "Wartung als Vorlage speichern",
      maintenance_repetition_yearly: "jährlich",
      maintenance_repetition_onetime: "einmalig",
      maintenance_repetition_oneweek: "Woche",

      maintenance_repetition_twoweek: "Wochen",

      maintenance_repetition_month: "Monat",
      maintenance_repetition_months: "Monate",
      maintenance_reminder_Week: "Woche",
      maintenance_reminder_Weeks: "Wochen",
      maintenance_reminder_Days: "Tage",
      maintenance_reminder_month: "Monat",
      maintenance_next_termine: "nächster Termin",
      maintenance_report: "Report",
      maintenance_report_empty: "Es wurde noch kein Report erstellt.",
      maintenance_report_add_btn: "Report erstellen",
      protocol_executed: "Ausführungsdatum",
      protocol_title: "Bericht Erstellen",
      protocol_title: " Report über Durchführung erstellen",
      protocol_comments: "Bermerkung eingeben...",
      protocol_title_pretext: "Durchgeführt am",
      protocol_title_posttext: "von",
      protocol_description: "Zusammenfassung",
      protocol_update: "Report Bearbeiten",
      menu_Instandhaltung: "Instandhaltung",
      menu_Instandhaltung_submenu: "Meldungen",
      menu_Instandhaltung_submenu1: "Geplante Wartungen",
      menu_Instandhaltung_submenu2: "Aufgabenplanung",

      no_maintenancetask: "Keine Wartungsaufgabe verfügbar",
      edit_equipment: "Speichern",
      edit: "Bearbeiten",
      delete: "Löschen",
      nav_machinetype: "Maschinentypen",
      nav_customermachines: "Kundenmaschinen",
      nav_customermachines_allmachine: "Alle Maschinen",
      nav_customermachines_analysis: "Analyse",
      nav_servicemanagement: "Servicemanagement",
      nav_administration: "Administration",
      all_brands: "Alle Marken",
      brand: "Marken",
      create_equipment_type: "Create MachinenTypen",
      update_equipment_type: "Update MachinenTypen",
      delete_equipment_type: "Delete MachinenTypen",
      create_brand: "Create Brand",
      update_brand: "Update Brand",
      delete_brand: "Delete Brand",
      create_equipment_class: "Create Equipment Class",
      update_equipment_class: "Update Equipment Class",
      delete_equipment_class: "Delete Equipment Class",
      customer_equipments: "Kundenmaschinen",
      customer_contact: "Kundenkontakt",

      history_filter_created: "Erstellt",
      history_filter_closed: "Abgeschlossen",
      history_filter_type: "Typ",
      history_filter_status: "Status",
      history_filter_keyword: "Stichwort",
      history_filter_reset: "zurücksetzen",
      history_filter_export: "Auswahl exportieren",
      history_filter_actions: "PDF erzeugen",
      systemCreated: "System Created",
      allMachines: "Alle Maschinen",
      allMachinePools: "Alle Maschinenparks",
      allSites: "Alle Werke",
      no_open_notification: "keine offen meldung",
      abo_title: "IHR 247UPTIME ABO",
      abo_complete_title: "247UpTime Abo abschließen",
      number_of_packages: "Anzahl Pakete",
      total_price: "Gesamtpreis (netto) pro Monat",
      billing_address_title: "Rechnungsadresse",
      companyName: "Unternehmen *",
      street_and_house_number: "Straße und Hausnummer *",
      post_code: "PLZ *",
      city: "Ort *",
      address_supplement: "Adresszusatz (optional)",
      land: "Land",
      emailEmail_for_invoicing: "E-Mail für Rechnungsstellung",
      contact_person: "Ansprechpartner",
      firstName: "Vorname *",
      lastName: "Nachname *",
      department: "Abteilung (optional)",
      cost_center: "Kostenstelle (optional)",
      personal_number: "Personal-Nummer (optional)",
      details_comment: "Qualifikationen (optional) eingeben...",
      specialization: "Fachausrichtung (optional)",
      telephoneNumber: "Telefonnumer",
      customer_service_title: "Sie haben Fragen?",
      customer_service_number: "+49 (0)8158 9239817",
      customer_service_email: "247uptime@247factorynet.com",
      customer_service_time: "Mo.–Fr. 09–18 Uhr",
      your_advantage: "IHRE VORTEILE",
      choose_subscription_title: "Gewünschtes Abo wählen",
      select_package: "Anzahl der Pakete wählen",
      invoice_title: "Rechnungsstellung",
      invoice_address: "Rechnungsadresse",
      invoice_edit: "Bearbeiten",
      purchaseComplete_title: "Kauf abschließen",
      order_title: "Vielen Dank für Ihre Bestellung",
      order_finished_message:
        "Die Bestellung des Abonnements ist abgeschlossen. Kehren Sie zur mobilen App zurück.",
      documentationTab_dragAndDrop_text:
        "Sie haben noch keine Dateien in dieser Kategorie hochgeladen",
      documentationTab_dragAndDrop_caption:
        "Laden Sie eine Datei hoch. Tipp: Sie können auch mehrere Dateien",
      dragAndDrop_btn: "+ DATEI HOCHLADEN",
      product_types_docs_title: "Produktspezifische Dokumente",
      product_types_docs_upload: "DATEI HOCHLADEN",
      product_types_docs_empty_title:
        "Sie haben noch keine Dateien in dieser Kategorie hochgeladen",
      product_types_docs_empty_hint:
        "Laden Sie eine Datei hoch. Tipp: Sie können auch mehrere Dateien gleichzeitig hochladen.",
      product_types_docs_empty_action: "DATEI HOCHLADEN",
      product_types_docs_file: "Datei",
      product_types_docs_uploading: "Dateien werden hochgeladen",
      product_types_docs_drop_hint:
        "Lassen Sie die Datei los, um sie dieser Produkttyp-Kategorie zuzuordnen.",
      product_types_docs_category_operation: "Bedienen und Einrichten",
      product_types_docs_category_setup: "Rüsten",
      product_types_docs_category_maintenance: "Wartung und Service",
      product_types_docs_category_safety: "Sicherheit",
      product_types_docs_category_internal: "Interne Anweisungen",
      nav: {
        customerPortal: "Kunden Portal",
        customerTrainings: "Kundentrainings",
        dashboard: "Dashboard",
        adminArea: "Adminbereich",
        customerManagement: "Kundenmanagement",
        contentManagement: "Content Management",
        customers: "Kunden",
        productTypes: "Produkttypen",
        spareParts: "Ersatzteile",
        trainings: "Schulungen",
        equipment: "Equipment",
        machineParks: "Maschinenparks",
        sites: "Werke",
        createNewSite: "Neues Werk anlegen",
        machines: "Maschinen",
        plannedMaintenance: "Geplante Wartung",
        taskPlanning: "Aufgabenplanung",
        notifications: "Meldungen",
        users: "Benutzer",
        brands: "Marken",
        equipmentClasses: "Equipment-Klassen",
      },
      auth: {
        loginHeading: "Anmelden",
        loginButton: "Anmelden",
        passwordLabel: "Passwort",
        forgotPassword: "Passwort vergessen?",
        registration: "Registrierung",
        noAccount: "Sie haben noch kein Konto?",
        registerForFree: "Kostenlos registrieren",
        changeEmailAddress: "E-Mail-Adresse ändern",
        signupHeadline: "247UpTime 30 Tage kostenfrei testen",
        signupFeature1: "Alle Funktionen und Bereiche testen",
        signupFeature2: "Sofortige Bereitstellung",
        signupFeature3: "Keine Kreditkarte notwendig",
        signupMailNotice:
          "Bitte prüfen Sie Ihr Postfach: Eine E-Mail mit Ihrem Aktivierungslink wurde an %s gesendet.",
        signupMailHint: "Klicken Sie auf den Link, um Ihre Registrierung abzuschließen.",
        createAccount: "Konto erstellen",
        toLogin: "Zur Anmeldung",
        or: "oder",
        signupContinue: "Weiter",
      },
      help: {
        documentation: "Dokumentation",
        feedback: "Feedback",
        faq: "Häufige Fragen und Antworten",
        sendFeedback: "Feedback absenden",
        feedbackSentTitle: "Nachricht gesendet",
        feedbackSentText: "Vielen Dank! Wir bearbeiten Ihr Anliegen so bald wie möglich.",
        feedbackTitle: "Feedback hinterlassen",
        feedbackTypeLabel: "Typ der Meldung",
        feedbackMessagePlaceholder: "Ihre Nachricht an uns...",
        chooseFile: "Datei auswählen...",
        supportPerson: "Konstantin",
        supportHours: "Mo.–Fr. 08–16 Uhr",
        feedbackTypeGeneral: "Generelles Feedback",
        feedbackTypeSetup: "Probleme beim Einrichten",
        feedbackTypeOperation: "Probleme beim Betrieb",
        feedbackTypeFeatures: "Funktionalität und Features",
        feedbackTypeOther: "Sonstiges",
      },
      site: {
        back: "Werke",
        createTitle: "Werk erstellen",
        updateTitle: "Werk bearbeiten",
        delete: "Werk löschen",
        nameLabel: "Name des Werks",
        nameExample: "z.B.: Werk Oberpfaffenhofen",
        streetLabel: "Straße und Hausnummer",
        addonLabel: "Adresszusatz (optional)",
        zipLabel: "PLZ",
        cityLabel: "Ort",
        countryLabel: "Land",
        description:
          "Hier verwalten Sie die Stammdaten eines Werks. Nachdem das Werk erstellt wurde können Sie Bereiche erstellen und Equipment zuordnen.",
      },
      area: {
        createTitle: "Bereich erstellen",
        updateTitle: "Bereich bearbeiten",
        delete: "Bereich löschen",
        scopeTitle: "Bereiche",
        description:
          "Ihr Werk kann in beliebig viele Bereiche eingeteilt werden, welchen Ihr Equipment zugewiesen ist.",
        nameLabel: "Name des Bereichs",
        nameExample: "z.B.: Gehäusefertigung",
        idLabel: "Bereichs-ID",
        equipment: "Zugeordnetes Equipment",
        selectEquipment: "Equipment auswählen",
        operatingParameters: "Betriebsparameter",
        operatingHours: "Betriebszeiten",
        copySettingsFromArea: "Einstellungen aus Bereich übernehmen",
        chooseArea: "Bitte wählen Sie einen Bereich aus",
        configure: "Konfigurieren",
        operatingParametersEmpty:
          "Es wurden noch keine Betriebsparameter für %s angelegt.",
        operatingHoursEmpty:
          "Es wurden noch keine Betriebszeiten für %s angelegt.",
      },
      profile: {
        pageTitle: "Ihr Profil",
        additionalDetails: "Zusätzliche Details",
        headingSafety: "Sicherheit",
        passwordSection: "Ihr Passwort",
        passwordDescription:
          "Zum Ändern Ihres Passworts geben Sie Ihr aktuelles Passwort und Ihr neues Passwort ein. Ihr Passwort muss mindestens 8 Zeichen lang sein und einen Groß- sowie einen Kleinbuchstaben enthalten.",
        closeWindow: "Fenster schließen",
        uploadNewImage: "Neues Bild hochladen",
        deletePhoto: "Foto löschen",
        currentPassword: "Ihr aktuelles Passwort",
        newPassword: "Neues Passwort eingeben",
        emailLabel: "E-Mail",
        enterValidEmail: "Geben Sie Ihre gültige E-Mail-Adresse ein",
        reset: "Zurücksetzen",
        yourPassword: "Ihr Passwort",
        twoFactorTitle: "2-Faktor-Authentifizierung einrichten",
        twoFa_desc: "geben Sie bitte hier Ihren sechsstelligen Authentifizierungs-Code ein.",

        twoFactorDescription:
          "Die 2-Faktor-Authentifizierung macht den Zugriff auf Ihr Benutzerkonto noch sicherer. Zur Nutzung benötigen Sie Zugriff auf ein mobiles Endgerät mit der Google Authenticator App.",
        twoFactorImportant:
          "Wichtig: Bitte wenden Sie sich an den Support, wenn Sie Änderungen an Ihrer 2-Faktor-Authentifizierung vornehmen möchten oder Ihr Gerät verloren haben.",
        twoFactorSupportPrefix: "Wichtig: Bitte wenden Sie sich an den",
        twoFactorSupportSuffix:
          "wenn Sie Änderungen an Ihrer 2-Faktor-Authentifizierung vornehmen möchten oder Ihr Gerät verloren haben.",
        setupNow: "JETZT EINRICHTEN",
        twoFactorActive: "2-Faktor-Authentifizierung aktiviert",
        assignedEquipment: "Zugewiesenes Equipment",
        assignedEquipmentHint:
          "Wichtig: Nur hier ausgewähltes Equipment wird Ihnen im Dashboard angezeigt. Nur für ausgewähltes Equipment erhalten Sie Benachrichtigungen zu Meldungen und anstehenden Wartungen.",
        sitesAndAreas: "Werke und Bereiche",
        equipmentPools: "Equipment Pools",
        profileEquipmentHint:
          "Hier fügen Sie Ihrem Profil Equipments, z. B. Maschinen, hinzu, um diese im Dashboard anzuzeigen und um Push-Nachrichten zu erhalten.",
        languageLabel: "Sprache",
        languageGerman: "Deutsch",
        languageEnglish: "Englisch",
      },
      users: {
        tabSubscription: "Ihr Abo",
        tabUsers: "Benutzer",
        subscriptionSummaryTitle: "Zusammenfassung Ihres Abos",
        currentPlan: "Derzeitiges Abo",
        term: "Laufzeit",
        subscribedOn: "Abonniert am",
        autoRenewal: "Autom. Verlängerung",
        noticePeriod: "Kündigungsfrist",
        organizationName: "Name Ihrer Organisation",
        userLimit: "User-Limit",
      subscription: "Abo",
        billingTitle: "Rechnungsstellung",
        billingShipping: "Rechnungsversand",
        shipTo: "Versand an",
        contactSupport:
          "Für Änderungen am Abo oder der Rechnungsstellung kontaktieren Sie bitte den Kundenservice.",
        faqTitle: "Häufige Fragen und Antworten",
        machine_faq_description:
          "Hier finden Sie häufige Fragen und Antworten zu dieser Maschine und können eigene Fragen und Antworten dokumentieren.",
        customerServiceTitle: "Kundenservice",
        searchPlaceholder: "Benutzer durchsuchen",
        filterButton: "FILTER",
        filterAccountStatus: "User-Account-Status",
        filterUserType: "Benutzertyp",
        statusAll: "alle",
        statusActive: "Aktive",
        statusInactive: "In-Aktive",
        addNew: "+ NEU",
        tableStatus: "Status",
        tableFirstName: "Vorname",
        tableLastName: "Nachname",
        tableUserType: "Benutzertyp",
        tableEmail: "E-Mail-Adresse",
        rowsPerPage: "Einträge pro Seite",
        newMessage: "Neue Nachricht",
        actions: "Aktionen",
        faqQ1:
          "Ich benötige mehr User als mein Limit zulässt. Wie kann ich weitere hinzubuchen?",
        faqA1:
          'Bitte senden Sie eine Email an <a href="mailto:247uptime@247factorynet.com">247uptime@247factorynet.com</a> mit der Angabe Ihrer Subscription ID und der gewünchen Anzahl Ihrer User.',
        faqQ2: "Wie kann ich weitere Administratoren erstellen?",
        faqA2: "Erstellen Sie einfach einen neuen User und geben Sie diesem die Rolle Admin.",
        faqQ3: "An wen kann ich mich bei technischen Fragen wenden?",
        faqA3: "Bitte wenden Sie sich mit allen Anliegen an support@247factorynet.com",
        faqQ4: "Wie verwalte ich meinen eigenen Benutzeraccount?",
        faqA4:
          "Bitte wählen Sie Profil & Einstellungen neben Ihrem Namen rechts oben im Bildschirm.",
        faqQ5: "Wie kann ich mein 247uptime Abo kündigen?",
        faqA5:
          'Wenn Sie Ihr Abo kündigen möchten, teilen Sie uns dies bitte per Mail an <a href="mailto:247uptime@247factorynet.com">247uptime@247factorynet.com</a> unter Angabe Ihrer Subscription ID mit.',
        billingElectronic: "Elektronisch (per E-Mail)",
      },

         customerPortal_tabCustomerPortals: "Kundenportale",
      customerPortal_tabSettings: "Einstellungen",
      customerPortal_tableTitle: "Kundenportale",
      customerPortal_searchPlaceholder: "Kunden durchsuchen",
      customerPortal_statusLabel: "Status",
      customerPortal_statusAll: "alle",
      customerPortal_statusPublished: "veröffentlicht",
      customerPortal_statusPlanned: "in Planung",
      customerPortal_statusOffline: "offline",
      customerPortal_statusNotConfigured: "nicht eingerichtet",
      customerPortal_emptyTitle: "Sie haben noch keinen Kunden erstellt",
      customerPortal_emptyHint:
        "Um ein Kundenportal verwalten zu können, müssen Sie zunächst einen Kunden anlegen.",
      customerPortal_emptyAction: "Neuen Kunden anlegen",
      customerPortal_entriesPerPage: "%s Einträge pro Seite",
      customerPortal_settingsTitle: "Einstellungen",
      customerPortal_settingsDescription:
        "Die hier konfigurierten Einstellungen wirken sich auf alle Kundenportale aus, insofern Sie keine gesonderten Einstellungen für ein Kundenportal getroffen haben.",
      customerPortal_displayTitle: "Darstellung Ihrer Kundenportale",
      customerPortal_logoUploadLabel: "Logo hochladen",
      customerPortal_logoLabel: "Logo",
      customerPortal_primaryColorLabel: "Primärfarbe",
      customerPortal_hexLabel: "HEX-Code",
      customerPortal_previewTitle: "Vorschau Ihres Kundenportal-Stils",
      customerPortal_bannerTitle: "Kopfbereiche",
      customerPortal_bannerDescription: "So sehen Kopfbereiche innerhalb der Anwendung aus.",
      customerPortal_previewHeadline: "Hauptüberschriften",
      customerPortal_previewLinks: "Links",
      customerPortal_previewDefaultText: "Standard-Text",
      customerPortal_previewPrimaryButton: "+ Schaltfläche",
      customerPortal_previewSecondaryButton: "+ Schaltfläche",
      customerPortal_saveChanges: "ÄNDERUNGEN SPEICHERN",
      customerPortal_portalUrlTitle: "URL für Kundenportale",
      customerPortal_portalUrlDescription:
        "Sie können für Ihre Kundenportale eine firmen­eigene Adresse hinterlegen.",
      customerPortal_portalUrlDescriptionSuffix: "Bitte nutzen Sie hierzu",
      customerPortal_standardAddressNote:
        "Ihr Kundenportal ist zusätzlich immer unter der Standard-Adresse erreichbar.",
      customerPortal_standardAddressLabel: "Standard-Adresse",
      customerPortal_openGuideLink: "unsere Anleitung",
      customerPortal_customAddressLabel: "Benutzerdefinierte Adresse",
      customerPortal_customAddressPlaceholder: "z. B. kundenname.de/kundenportal",
      customerPortal_customAddressExample: "z. B. kundenname.de/kundenportal",
      customerPortal_helpStatusLabel: "Status",
      customerPortal_siteTableTitle: "Standorte",
      customerPortal_siteSearchPlaceholder: "Standorte durchsuchen",
      customerPortal_siteHeaderName: "Standortname",
      customerPortal_siteHeaderCompany: "Unternehmen",
      customerPortal_siteHeaderCity: "Ort",
      customerPortal_siteHeaderCountry: "Land",
      customerPortal_siteHeaderMachines: "Maschinen",
      customerPortal_helpTitle: "Einrichtung einer benutzerdefinierten Adresse",
      customerPortal_helpIntro:
        "Um Ihre Kundenportale unter Ihrer eigenen Domain erreichbar zu machen, sind einige Schritte nötig. Bitte wenden Sie sich mit dieser Anleitung an Ihren Webadministrator.",
      customerPortal_helpStep1Title: "1. 247Access: URL in den Einstellungen eintragen",
      customerPortal_helpStep1Body:
        "Tragen Sie Ihre benutzerdefinierte Webadresse (z. B. https://kundenname.de/kundenportal/) in 247Access ein und speichern Sie Ihre Änderungen.",
      customerPortal_helpStep1StatusPrefix:
        "Nachdem Sie eine gültige URL eingetragen haben, sehen Sie den Status",
      customerPortal_helpStep1StatusValue: "Erreichbarkeit ausstehend",
      customerPortal_helpStep2Title: "2. Ihr Server: Änderungen vornehmen",
      customerPortal_helpStep2Body:
        "Sie haben die Möglichkeit eine der folgenden Konfigurationsoptionen zu wählen. Entnehmen Sie die URLs der vorherigen Seite.",
      customerPortal_helpDnsTitle: "DNS Eintrag:",
      customerPortal_helpDnsBody:
        "Erstellen Sie einen CNAME Eintrag, welcher von Ihrer benutzerdefinierten Webadresse auf Ihre Standard-Adresse verweist.",
      customerPortal_helpProxyTitle: "Reverse-Proxy:",
      customerPortal_helpProxyBody:
        "Leiten Sie Anfragen von Ihrer Standard-Adresse zu Ihrer benutzerdefinierten Adresse um.",
      customerPortal_helpStep2Footer:
        "Bitte beachten Sie, dass die Änderungen bis zu 48 Stunden in Anspruch nehmen können. Nachdem Ihre Kundenportale unter Ihrer benutzerdefinierten Adresse erreichbar sind, sehen Sie den Status",
      customerPortal_helpStep2StatusValue: "Kundenportal erreichbar",
      customerPortal_closeWindow: "Fenster schließen",
      reset_password_title: "Passwort zurücksetzen",
      reset_password_description:
        "Sie erhalten eine E-Mail zum Zurücksetzen Ihres Passworts.",
      reset_password_request_button: "E-MAIL ANFORDERN",
      reset_password_back_to_login: "Zurück zum Login",
      reset_password_success:
        "Wir haben eine E-Mail an Ihr Konto gesendet. Bitte prüfen Sie Ihr Postfach. Danke.",
      reset_password_login_link: "==>Login Page",
      email_address: "E-mail-Adresse",

      customerTrainings_pageTitle: "Kundentrainings",
      customerTrainings_filterBooked: "Nur gebuchte anzeigen",
      customerTrainings_introTitle: "Individuelle Trainings",
      customerTrainings_introDescription:
        "Bei Fragen zu den Inhalten oder dem Wunsch nach maßgeschneiderten Trainings wenden Sie sich gerne an uns.",
      customerTrainings_contactName: "Luisa Herrgardt",
      customerTrainings_contactEmail: "trainings@fette-compacting.com",
      customerTrainings_contactHours: "Mo.–Fr. 09–18 Uhr",
      customerTrainings_durationLabel: "Dauer",
      customerTrainings_duration1Day: "Dauer: 1 Tag",
      customerTrainings_duration2Days: "Dauer: 2 Tage",
      customerTrainings_cardActionStart: "Training Starten",
      customerTrainings_cardActionBook: "Training Buchen",
      customerTrainings_bookingSuccess: "Training erfolgreich gebucht.",
      customerTrainings_bookingError: "Training konnte nicht gebucht werden.",
      customerTrainings_apiError:
        "Kundentrainings konnten nicht aus der API geladen werden.",
      customerTrainings_emptyState: "Keine Kundentrainings verfügbar.",
      customerTrainings_module1_title: "Einführung",
      customerTrainings_module1_target:
        "Zielgruppe: Maschinenbediener, Instandhaltungspersonal, Maschineneinrichter, Projektentwickler, Qualitätsmanager, Technologen, Projektmanager, IT-Administratoren, Produktionsleiter",
      customerTrainings_module1_description:
        "Nach diesem Training beherrschen Sie das Funktionsprinzip einer Tablettenpresse und sind mit den Fachbegriffen vertraut. Sie kennen alle Sicherheitsfunktionen der Maschinen und haben Ihre erste Tablette produziert.",
      customerTrainings_module2_title: "Bedienung",
      customerTrainings_module2_target:
        "Zielgruppe: Maschinenbediener, Maschineneinrichter, Qualitätsmanager, Technologen",
      customerTrainings_module2_description:
        "In diesem Training lernen Sie, die Tablettenpresse sicher und effizient einzurichten und zu bedienen. Sie üben die wichtigsten Arbeitsschritte und lernen den sicheren Umgang mit typischen Produktionssituationen.",
      customerTrainings_module3_title: "Instandhaltung Mechanik",
      customerTrainings_module3_target:
        "Zielgruppe: Instandhaltungspersonal",
      customerTrainings_module3_description:
        "Dieses Training vermittelt mechanische Wartungsaufgaben, Prüfabläufe und den sicheren Umgang mit den Maschinenkomponenten.",
      customerTrainings_module4_title: "Instandhaltung Elektronik",
      customerTrainings_module4_target:
        "Zielgruppe: Instandhaltungspersonal",
      customerTrainings_module4_description:
        "Dieses Training behandelt elektronische Komponenten, Diagnosen und die sichere Fehlersuche an der Tablettenpresse.",
      customerTrainings_module5_title: "Ausbauarm",
      customerTrainings_module5_target:
        "Zielgruppe: Instandhaltungspersonal",
      customerTrainings_module5_description:
        "Hier lernen Sie den sicheren Umgang mit dem Ausbauarm und die effiziente Durchführung von Servicearbeiten an der Maschine.",
      customerTrainings_module6_title: "Reinigen und Rüsten",
      customerTrainings_module6_target:
        "Zielgruppe: Instandhaltungspersonal, Maschinenbediener",
      customerTrainings_module6_description:
        "Dieses Training behandelt das Reinigen, Rüsten und die sichere Vorbereitung der Tablettenpresse auf den nächsten Produktionslauf.",
      customerTrainings_detailBack: "Kundentrainings",
      customerTrainings_detailInfoCustomer: "Kunde: Pfizer Deutschland",
      customerTrainings_detailInfoUserId: "User ID",
      customerTrainings_detailTabOverview: "Übersicht",
      customerTrainings_detailTabDigitalLearning: "Digitaler Lernraum",
      customerTrainings_detailAboutTitle: "Über dieses Training",
      customerTrainings_detailTargetGroupTitle: "Zielgruppe",
      customerTrainings_detailDownloadsTitle: "Downloads zu Modulen",
      customerTrainings_detailLanguageLabel: "Sprache",
      customerTrainings_detailLanguageGerman: "Deutsch",
      customerTrainings_detailLanguageFrench: "Französisch",
      customerTrainings_detailLanguageEnglish: "Englisch",
      customerTrainings_detailDownloadsEmpty:
        "Für die ausgewählte Sprache sind keine Anhänge verfügbar.",
      customerTrainings_detailSectionGeneral: "Allgemeine Inhalte (4)",
      customerTrainings_detailSectionAdvanced: "Vertiefende Inhalte (12)",
      customerTrainings_detailSectionKnowledgeCheck: "Lernzielkontrolle (4)",
      customerTrainings_detailSectionCertificates: "Zertifikate (3)",
      customerTrainings_detailDocItem1Title: "P3000 Bedienungsanleitung 2023-01",
      customerTrainings_detailDocItem1Description:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit.",
      customerTrainings_detailDocItem2Title: "Bedienungsanleitung Aufsatz ZQP2",
      customerTrainings_detailDocItem2Description:
        "Lorem ipsum dolor sit aiscing elit. Aenean commodo ligula eget dolor.",
      customerTrainings_detailDocItem3Title: "Zusatzinformation P3000",
      customerTrainings_detailDocItem4Title: "Sicherheitseinweisung P3000",
      customerTrainings_detailSectionComingSoon:
        "Inhalte für diesen Abschnitt sind in Kürze verfügbar.",
      customerTrainings_detailDigitalLearning: "Digitaler Lernraum",
      customerTrainings_detailDigitalLearningHint:
        "Digitale Trainingsinhalte für dieses Modul sind vorbereitet und bald verfügbar.",
    },
  };

  const activeLanguage = localizedStrings[language] ? language : "de";

  return {
    // ...localizedStrings.de,
    ...(localizedStrings[activeLanguage] || {}),
  };
}

export default i18n;
